
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, ComponentFactoryResolver, QueryList, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { alert, confirm } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import { NgxSpinnerService } from 'ngx-spinner';
import { NicaDataGridComponent } from '../components/nica-data-grid/nica-data-grid.component';
import { NewNicaFormComponent } from '../components/nica-form/new-nica-form.component';
import { NicaMaster } from '../components/nica-master-component/nica-master.component';
import { NicaFiltroComponent } from '../components/shared/nica-filtro/nica-filtro.component';
import { OverlaySideFormService } from '../components/shared/overlay-side-form/overlay-side-form.service';
import { AnagraficaService } from '../services/anagrafica.service';
import { ComponentService } from '../services/component.service';
import { FormsTemplateService } from '../services/forms-template.service';
import { NicaMenuService } from '../services/nica-menu.service';
import { RentriService } from '../services/rentri.service';


const registriPanelMovimenti = {
  dynamic: {
    dataSource: "",
    service: '',
    valueExpr: '',
    displayExpr: 'eer',
    searchExpr: '',
    caption: "",
    filterStatic: '',
    queryStringFilter: '',
    componentType: 'dynamicGrid',
    settingGrid: {
      masterKey: '',
      keyUnique: '',
      mode: null,
      selectionMode: 'none',
      remoteOperations: false,
      hoverStateEnabled: true,
      rowAlternationEnabled: true,
      showFilterSearch: false,
      repaintChangesOnly: true,
      allowUpdating: false,
      allowDeleting: false,
      allowAdding: false,
      height: 200,
      showColBlank: false,
      colonne: [
        {
          dataField: 'tipoRegistro',
          dataType: '',
          caption: ' ',
          colWidth: '100px',
          allowEditing: false,
        },
        {
          dataField: 'registro_Descrizione',
          dataType: '',
          caption: ' ',
          colWidth: '300px',
          allowEditing: false,

        },


      ],

    }

  }
}

interface FilterData {
  totalCount: number | null;
  items: any[]; // Utilizza `any[]` per accettare array di qualsiasi oggetto
}

export class MovDoc extends NicaMaster {

  @ViewChild('formMovimento', { static: false }) formMovimento: NewNicaFormComponent;
  @ViewChild('nicaFiltro', { static: false }) nicaFiltro: NicaFiltroComponent;

  calcolaVolumePeso: string;
  pesoSpecificoKGMC: any;
  filterTemplateKey?: string;
  pannelloFiltriAvanzatiVisibile: boolean = false;
  disableCerDesc: boolean = false;
  isEnabeldSessionStorage: boolean = true;
  tempGuid: string;
  // copyArray: any[] = [];
  constructor(
    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    public loader: NgxSpinnerService,
    public formservice: FormsTemplateService,
    public cd?: ChangeDetectorRef,
    public http?: HttpClient,
  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService,


    );


  }

  ngOnInit() {
  }

  /****Manipola la form dei movimenti e formulari****/


  async renderFormMovDoc(event) {
    if (this.template != 'form') {
      return false;
    }
    if (event.formData && event.formData['spurghi'] === true) {
      if (event.component && event.component.elementRef && event.component.elementRef.produttore_Descrizione_Soggetto) {
        const produttore_Descrizione_Soggetto = event.component.elementRef.produttore_Descrizione_Soggetto
        if (produttore_Descrizione_Soggetto.campo && produttore_Descrizione_Soggetto.campo.dynamic) {

          const index = produttore_Descrizione_Soggetto.campo.dynamic.queryString.indexOf('TipoAttivita=');
          const result = index !== -1 ? produttore_Descrizione_Soggetto.campo.dynamic.queryString.substring(index) : produttore_Descrizione_Soggetto.campo.dynamic.queryString;
          produttore_Descrizione_Soggetto.campo.dynamic.queryString = `?${result}`
        }
      }
    }
    const isEdit = this.filterID['isEdit']
    const form = event.component
    //form.timerCheck = 6000;
    if (this.filterID['idCaricoAutomatico'] && this.template == 'form' && !isEdit) {

      let validationRules = [{
        type: 'required',
        message: 'Magazzino scarico obbligatorio'
      }]

      form.itemOption('dati-generali-movimento.magazzinoProduttore_Descrizione', 'validationRules', validationRules);

    } else {

      form.itemOption('dati-generali-movimento.magazzinoProduttore_Descrizione', 'validationRules', null);
      form.itemOption('dati-generali-movimento.magazzinoProduttore_Descrizione', 'disabled', true);

    }

    if (isEdit && this.apiset == 'MovimentoRifiuti') {
      const sssssssssss = form.getInputsComponents('numeroFormulario')
      sssssssssss.component.buttonOptionType2[0].disabled = true
    }

    if (isEdit && this.apiset == 'MovimentoRifiuti') {
      const formData = form.dataSet;


      if (formData['protocolloCarico'] || formData['protocolloScarico'] || formData['protocolloTrasporto'] || formData['protocolloIntermediario'] || formData['protocolloGiacenzaIniziale']) {
        let tipoRegistro = '<ul>'
        tipoRegistro += formData['protocolloCarico'] ? '<li>Registro di carico</li>' : '';
        tipoRegistro += formData['protocolloScarico'] ? '<li>Registro di scarico</li>' : '';
        tipoRegistro += formData['protocolloTrasporto'] ? '<li>Registro di trasporto</li>' : '';
        tipoRegistro += formData['protocolloIntermediario'] ? '<li>Registro di intermediazione</li>' : '';
        tipoRegistro += formData['protocolloGiacenzaIniziale'] ? '<li>Registro di giacenza iniziale</li>' : '';
        tipoRegistro += '</ul>'

        let message = ""
        message += `<p>Il documento selezionato è stato già protocollato su i seguenti registri: </p>`
        message += `${tipoRegistro}`

        alert(message, "Si Avverte che:");
      }
    }

    if (this.apiset == 'DocumentoRifiuti') {
      const sssssssssss = form.getInputsComponents('numeroFormulario')
      sssssssssss.component.buttonOptionType2[0].disabled = true
    }


    if (this.filterID['causale_Id_Operazione'] && this.template == 'form') {

      const idOperazione = this.filterID['causale_Id_Operazione']
      const isSpurghi = event.formData.spurghi
      if (this.SubjectCall == 'movimentiRifiuto') {

        // Per operazione A1 cambio l'etichetta del gruppo Destinatario 

        if (idOperazione == 'A1') {

          form.itemOption('dati-generali-movimento.destinatario_Descrizione_Soggetto', 'setLabel', "Deposito temp.");
          //form.itemOption('dati-generali-movimento.destinatario_Descrizione_Soggetto', 'setLabel', 'NS Deposito Temp');
          form.itemOption('dati-generali-movimento.idOperazioneRD', 'setLabel', "Mod.presunta");

          form.itemOption('dati-generali-movimento.idOperazioneRD', 'validationRules', null);

          form.itemOption('dati-generali-movimento.autorizzazioneDestinatario_Descrizione_Full', 'disabled', false);

          form.itemOption('dati-generali-movimento.autorizzazioneDestinatarioArea_Full', 'disabled', false);

        }



        // Mostra magazzino del produttore solo se l'operazione è  C1 C2 C3


        if (['A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'B1', 'B2', 'B3'].some(id => { return idOperazione == id }) == true) {

          form.itemOption('dati-generali-movimento.lotto_Descrizione', 'disabled', false);



        }


        if (idOperazione == 'A1' || idOperazione == 'A2' || idOperazione == 'A4' || idOperazione == 'A5' || idOperazione == 'C3') {


          let validationRules = [{
            type: 'required',
            message: 'Magazzino destinatario è obbligatorio'
          }]

          form.itemOption('dati-generali-movimento.magazzinoDestinatario_Descrizione', 'validationRules', validationRules);


        }

        if (idOperazione == 'B1') {

          form.itemOption('dati-generali-movimento.quantitaKg', 'validationRules', null);


        }

        if (idOperazione == 'B1' || idOperazione == 'B2' || idOperazione == 'B3') {

          form.itemOption('dati-generali-movimento.magazzinoDestinatario_Descrizione', 'disabled', true);
          form.itemOption('dati-generali-movimento.magazzinoDestinatario_Descrizione', 'cssClass', 'label-magazzino,label-disabled,disabled-label-item');

          form.itemOption('dati-generali-movimento.autorizzazioneDestinatarioArea_Full', 'disabled', true);
          form.itemOption('dati-generali-movimento.autorizzazioneDestinatarioArea_Full', 'cssClass', 'label-soggetti,label-disabled,disabled-label-item');

        }

        //Controllo se la causale non prevede trasporto, procedo con il mostrare solo un avviso

        const trasporto = this.filterID['causale_Trasporto'];

        if (trasporto == 'N') {

          form.itemOption('dati-generali-movimento.trasportoDesc', 'visible', true);

          //Rendo non visibili i campi del trasportatore

          form.itemOption('dati-generali-movimento.trasportatore_Descrizione_Soggetto', 'cssClass', 'd-none');
          form.itemOption('dati-generali-movimento.trasportatore_Descrizione_Sede', 'cssClass', 'd-none');
          form.itemOption('dati-generali-movimento.trasportatore_NumDataIscrizioneAlbo', 'cssClass', 'd-none');
          form.itemOption('dati-generali-movimento.autorizzazioneTrasportatoreAlbo_Full', 'cssClass', 'd-none');
          form.itemOption('dati-generali-movimento.descCategoriaAlboTrasportatore', 'cssClass', 'd-none');
          form.itemOption('dati-generali-movimento.autista_Cognome_Nome', 'cssClass', 'd-none');
          form.itemOption('dati-generali-movimento.automezzo_Descrizione_Full', 'cssClass', 'd-none');
          form.itemOption('dati-generali-movimento.rimorchio_Descrizione', 'cssClass', 'd-none');
          form.itemOption('dati-generali-movimento.descrizione_Operatore_1', 'cssClass', 'd-none');
          form.itemOption('dati-generali-movimento.descrizione_Operatore_2', 'cssClass', 'd-none');
          form.itemOption('dati-generali-movimento.carrozzeriemobiliautomezzo', 'cssClass', 'd-none');
          form.itemOption('dati-generali-movimento.carrozzerieMobiliRimorchio', 'cssClass', 'd-none');

          form.addClassToElement('addElencoVettori', 'd-none');

          form.addClassToElement('addElencoOperatori', 'd-none');

          form.itemOption('dati-generali-movimento.dataInizioTrasporto', 'cssClass', 'disabled-label-item');
          form.itemOption('dati-generali-movimento.oraInizioTrasporto', 'cssClass', 'disabled-label-item');
          form.itemOption('dati-generali-movimento.dataFineTrasporto', 'cssClass', 'disabled-label-item');
          form.itemOption('dati-generali-movimento.oraFineTrasporto', 'cssClass', 'disabled-label-item');

          form.itemOption('dati-generali-movimento.adr', 'cssClass', 'disabled-label-item');
          form.itemOption('dati-generali-movimento.idONU', 'cssClass', 'disabled-label-item');
          form.itemOption('dati-generali-movimento.testoADR_Descrizione', 'cssClass', 'disabled-label-item');
          form.itemOption('dati-generali-movimento.idClasseAdr', 'cssClass', 'disabled-label-item');
          form.itemOption('dati-generali-movimento.numeroColli', 'cssClass', 'disabled-label-item');
          form.itemOption('dati-generali-movimento.tipoAccettazione', 'cssClass', 'disabled-label-item');
          form.itemOption('dati-generali-movimento.idMotivoRespinta', 'cssClass', 'disabled-label-item');
          form.itemOption('dati-generali-movimento.descrizioneRespinta', 'cssClass', 'disabled-label-item');


        }

        else {
          form.itemOption('dati-generali-movimento.trasportoDesc', 'visible', false);

          let validationRulesTrasporto = [{
            type: 'required',
            message: 'Trasportatore è obbligatorio'
          }];

          let validationRulesTrasportoUl = [{
            type: 'required',
            message: 'UL Trasportatore è obbligatoria'
          }]

          form.itemOption('dati-generali-movimento.trasportatore_Descrizione_Soggetto', 'validationRules', validationRulesTrasporto);
          form.itemOption('dati-generali-movimento.trasportatore_Descrizione_Sede', 'validationRules', validationRulesTrasportoUl);

          form.itemOption('dati-generali-movimento.dataInizioTrasporto', 'disabled', false);
          form.itemOption('dati-generali-movimento.oraInizioTrasporto', 'disabled', false);
          form.itemOption('dati-generali-movimento.dataFineTrasporto', 'disabled', false);
          form.itemOption('dati-generali-movimento.oraFineTrasporto', 'disabled', false);
          form.itemOption('dati-generali-movimento.unitaMisuraVolume', 'disabled', false);
          form.itemOption('dati-generali-movimento.oraInizioTrasporto', 'disabled', false);
          form.itemOption('dati-generali-movimento.dataFineTrasporto', 'disabled', false);
          form.itemOption('dati-generali-movimento.oraFineTrasporto', 'disabled', false);
          form.itemOption('dati-generali-movimento.adr', 'disabled', false);
          form.itemOption('dati-generali-movimento.numeroColli', 'disabled', false);
          form.itemOption('dati-generali-movimento.idImballo', 'disabled', false);
          form.itemOption('dati-generali-movimento.tipoAccettazione', 'disabled', false);
          form.itemOption('dati-generali-movimento.tipoAccettazione', 'disabled', false);

          form.itemOption('dati-generali-movimento.descrizioneRespinta', 'placeHolder', 'Specifica il motivo');


          /*  setTimeout(() => {
 
             form.getEditor('dataInizioTrasporto').option('disabled', false);
             form.getEditor('oraInizioTrasporto').option('disabled', false);
             form.getEditor('dataFineTrasporto').option('disabled', false);
             form.getEditor('oraFineTrasporto').option('disabled', false);
             form.getEditor('unitaMisuraVolume').option('disabled', false);
             form.getEditor('adr').option('disabled', false);
            
             form.getEditor('idONU').option('disabled', false);
             form.getEditor('numeroColli').option('disabled', false);
             form.getEditor('idImballo').option('disabled', false);
             form.getEditor('altriDatiFormulario').option('disabled', false);
             form.getEditor('tipoAccettazione').option('disabled', false);
        
 
 
 
 
           }, 300); */

        }


        //Mostra quantità quantitaOrigineKg,Unitamisura,verificatoPartenza se l'operazione  B2 B3 oppure se la causale ha trasporto P o X
        if (idOperazione == 'B2' || idOperazione == 'B3' || (trasporto == 'P' || trasporto == 'X')) {

          let validationRulesQuantitaOrigin = [{
            type: 'required',
            message: 'Peso partenza è obbligatorio'
          }]

          form.itemOption('dati-generali-movimento.quantitaOrigineKg', 'disabled', false);
          //form.itemOption('dati-generali-movimento.quantitaOrigineKg', 'cssClass', 'quantita-origine');
          //form.itemOption('dati-generali-movimento.quantitaOrigineKg','readOnly',false);
          form.itemOption('dati-generali-movimento.quantitaOrigineKg', 'validationRules', validationRulesQuantitaOrigin);
          form.itemOption('dati-generali-movimento.volume', 'disabled', false);
          //form.itemOption('dati-generali-movimento.volume','readOnly',false);
          form.itemOption('dati-generali-movimento.verificatoPartenza', 'disabled', false);
          form.itemOption('dati-generali-movimento.verificatoPartenza', 'cssClass', '');
          //form.itemOption('dati-generali-movimento.verificatoPartenza','readOnly',false);

          /* setTimeout(() => {

            form.getEditor('quantitaOrigineKg').option('disabled', false);
            form.getEditor('verificatoPartenza').option('disabled', false);

          }, 300); */

        }

        //Gestione campi idCantiereFuoriUl 

        if (idOperazione == 'A4' || idOperazione == 'A5' || idOperazione == 'C1' || idOperazione == 'C2' || idOperazione == 'D1' || idOperazione == 'D2' || idOperazione == 'D3') {

          form.itemOption('dati-generali-movimento.idCantiereFuoriUl', 'disabled', true);
          form.itemOption('dati-generali-movimento.cantiere_Descrizione', 'disabled', true);

        }


        if (idOperazione == 'A6' || idOperazione == 'A7' || idOperazione == 'B2' || idOperazione == 'B3') {

          form.itemOption('dati-generali-movimento.idCantiereFuoriUl', 'disabled', true);
          form.itemOption('dati-generali-movimento.cantiere_Descrizione', 'disabled', true);

        }


        ////Controllo se la causale prevede il Produttore o è in modifica, procedo con disabilitare il campo;
        const idProduttore = this.filterID['idProduttore'];
        const nsAziendaProd = await this.getInfoSede(idProduttore, 'nsAzienda')
        this.filterID['nsAziendaProd'] = nsAziendaProd;

        if (idProduttore != null && nsAziendaProd) {

          form.itemOption('dati-generali-movimento.idProduttore', 'disabled', true);
          form.itemOption('dati-generali-movimento.produttore_Descrizione_Soggetto', 'disabled', true);
          form.itemOption('dati-generali-movimento.produttore_Descrizione_Sede', 'disabled', true);
          form.itemOption('dati-generali-movimento.produttore_Descrizione_Soggetto', 'validationRules', null);

        } else if (idProduttore != null && isEdit && !nsAziendaProd) {

          form.itemOption('dati-generali-movimento.produttore_Descrizione_Soggetto', 'disabled', false);
          form.itemOption('dati-generali-movimento.produttore_Descrizione_Sede', 'disabled', false);
          form.itemOption('dati-generali-movimento.autorizzazioneProduttoreArea_Descrizione', 'disabled', true);

        } else if (!nsAziendaProd) {
          form.itemOption('dati-generali-movimento.autorizzazioneProduttoreArea_Descrizione', 'disabled', true);
        }

        //Controllo se la causale prevede il Destinatario, procedo con disabilitare il campo;
        const idDestinatario = this.filterID['idDestinatario'];

        const nsAziendaDest = await this.getInfoSede(idDestinatario, 'nsAzienda');

        if (idDestinatario != null && nsAziendaDest) {

          form.itemOption('dati-generali-movimento.idDestinatario', 'disabled', true);
          form.itemOption('dati-generali-movimento.destinatario_Descrizione_Soggetto', 'disabled', true);
          form.itemOption('dati-generali-movimento.destinatario_Descrizione_Sede', 'disabled', true);
          // form.itemOption('dati-generali-movimento.destinatario_Descrizione_Full','readOnly',true);
          form.itemOption('dati-generali-movimento.destinatario_Descrizione_Soggetto', 'validationRules', null);
          form.itemOption('dati-generali-movimento.destinatario_Descrizione_Sede', 'validationRules', null);

        } if (idDestinatario != null && isEdit && !nsAziendaDest) {

          form.itemOption('dati-generali-movimento.destinatario_Descrizione_Soggetto', 'disabled', false);
          form.itemOption('dati-generali-movimento.destinatario_Descrizione_Sede', 'disabled', false);
          form.itemOption('dati-generali-movimento.autorizzazioneDestinatarioArea_Full', 'disabled', true);
          //form.itemOption('dati-generali-movimento.destinatario_Descrizione_Full','readOnly',true);

        }

        //Controllo se la causale prevede il Trasportatore, procedo con disabilitare il campo;
        const idTrasportatore = this.filterID['idTrasportatore'];

        const nsAziendaTrasp = await this.getInfoSede(idTrasportatore, 'nsAzienda');
        this.filterID['nsAziendaTrasp'] = nsAziendaTrasp;
        if (idTrasportatore != null && nsAziendaTrasp) {

          form.itemOption('dati-generali-movimento.idTrasportatore', 'disabled', true);
          if (this.filterID['causale_Trasporto'] != 'X') {

            form.itemOption('dati-generali-movimento.trasportatore_Descrizione_Soggetto', 'disabled', true);
            form.itemOption('dati-generali-movimento.trasportatore_Descrizione_Sede', 'disabled', true);
            form.itemOption('dati-generali-movimento.trasportatore_Descrizione_Soggetto', 'validationRules', null);
            form.itemOption('dati-generali-movimento.trasportatore_Descrizione_Sede', 'validationRules', null);

          }



        } else if (idTrasportatore != null && isEdit && !nsAziendaTrasp) {

          form.itemOption('dati-generali-movimento.idTrasportatore', 'disabled', true);
          form.itemOption('dati-generali-movimento.trasportatore_Descrizione_Soggetto', 'disabled', false);
          form.itemOption('dati-generali-movimento.trasportatore_Descrizione_Sede', 'disabled', false);

          form.itemOption('dati-generali-movimento.trasportatore_Descrizione_Soggetto', 'validationRules', null);
          form.itemOption('dati-generali-movimento.trasportatore_Descrizione_Sede', 'validationRules', null);

        }

        const idIntermediario = this.filterID['idIntermediario'];

        const nsAziendaInt = await this.getInfoSede(idIntermediario, 'nsAzienda');

        if (idIntermediario != null && nsAziendaInt) {

          form.itemOption('dati-generali-movimento.idIntermediario', 'disabled', true);
          form.itemOption('dati-generali-movimento.intermediario_Descrizione_Soggetto', 'disabled', true);
          form.itemOption('dati-generali-movimento.intermediario_Descrizione_Sede', 'disabled', true);

        } else if (idIntermediario != null && isEdit && !nsAziendaInt) {

          form.itemOption('dati-generali-movimento.intermediario_Descrizione_Soggetto', 'disabled', false);
          form.itemOption('dati-generali-movimento.intermediario_Descrizione_Sede', 'disabled', false);


        }

        //Mostra i campi RAEE solo se l'operazione  è A1  A2 A3 A4 A5  B1  B2  E IL PROD. E/O SMALT. SONO CONFIGURATI Raee  

        if (this.apiset == 'DocumentoRifiuti') {
          if ((idOperazione == 'A1') && isSpurghi) {
            form.itemOption('dati-generali-movimento.addDatiRitiri', 'disabled', false);
          }

          if ((idOperazione == 'C1' || idOperazione == 'A4' || idOperazione == 'A5') && isSpurghi) {
            let model = form.dataSet
            if (model.idProduttore === model.idTrasportatore) {
              form.itemOption('dati-generali-movimento.addDatiRitiri', 'disabled', false);
            }
          }
        }

        if (idOperazione == 'A1' || idOperazione == 'A2' || idOperazione == 'A3' || idOperazione == 'A4' || idOperazione == 'A5' || idOperazione == 'B1' || idOperazione == 'B2') {
          const isGestioneRaee = this.filterID['isGestioneRaee']
          if (isGestioneRaee) {
            form.itemOption('dati-generali-movimento.tipoRaee', 'visible', true);
            form.itemOption('dati-generali-movimento.idCategoriaRaee', 'visible', true);

          }

          const isGestioneImballaggioProdotto = this.filterID['isGestioneImballaggioProdotto'];

          if (isGestioneImballaggioProdotto) {
            form.itemOption('dati-generali-movimento.prodottoDaImballaggi', 'visible', true);
          }

          const isimballaggioRicevuto = this.filterID['isGestioneImballaggioRicevuto'];

          if (isimballaggioRicevuto) {

            form.itemOption('raee-cobat-conou.imballaggioRicevuto', 'visible', true);
            form.itemOption('dati-generali-movimento.isAlluminio', 'visible', true);
          }

          const isVeicoloFuoriUso = this.filterID['isVeicoloFuoriUso'];

          if (isVeicoloFuoriUso) {
            form.itemOption('raee-cobat-conou.operazioneVeicoliFuoriUso', 'visible', true);
          }

        }

      }

    }


    await this.setDataBySessionStorage(form);

    this.userComponentService.outputComponent.subscribe(async currentOutput => {

      await this.updateDataBasedOnOutput(currentOutput, form);

    })



  }


  formItemsEventMovDoc(event) {

    if (event.name == "selectedItemLista") {
      if (event.campo.dataField == "adr") {

        if (event.value == 'S') {

          setTimeout(() => {
            this.formMovimento.itemOption('dati-generali-movimento.testoADR_Descrizione', 'disabled', false);
            this.formMovimento.itemOption('dati-generali-movimento.idClasseAdr', 'disabled', false);
            this.formMovimento.itemOption('dati-generali-movimento.idONU', 'disabled', false);
            //event.masterComponent.getEditor('testoADR_Descrizione').option('disabled', false);
            //event.masterComponent.getEditor('testoADR_Descrizione').option('readonly', false);
            //event.masterComponent.getEditor('idClasseAdr').option('disabled', false);
            //event.masterComponent.getEditor('idONU').option('disabled', false);

          }, 300);
        } else {
          setTimeout(() => {

            this.formMovimento.itemOption('dati-generali-movimento.testoADR_Descrizione', 'disabled', true);
            this.formMovimento.itemOption('dati-generali-movimento.idClasseAdr', 'disabled', true);
            this.formMovimento.itemOption('dati-generali-movimento.idONU', 'disabled', true);

            this.formMovimento.formRefreshInputData('testoADR_Descrizione', '')
            this.formMovimento.formRefreshInputData('idClasseAdr', null)
            this.formMovimento.formRefreshInputData('idONU', null);
          }, 300);
        }


      }

      if (event.campo.dataField == "tipoAccettazione") {

        /*
          { id: 'A', descrizione: 'Per intero' },
          { id: 'P', descrizione: 'Per quantità' },
          { id: 'R', descrizione: 'Respinto' }
        */

        if (event.value == 'R') {

          this.formMovimento.itemOption('dati-generali-movimento.quantitaRespinta', 'disabled', false);
          this.formMovimento.formRefreshInputData('quantitaKg', 0);

          let formData = this.formMovimento.dataSet
          this.formMovimento.formRefreshInputData('quantitaRespinta', formData.quantitaOrigineKg);

          this.formMovimento.itemOption('dati-generali-movimento.idMotivoRespinta', 'disabled', false);
          let validationRules = [{
            type: 'required',
            message: 'Specificare un motivo'
          }]
          this.formMovimento.itemOption('dati-generali-movimento.idMotivoRespinta', 'validationRules', validationRules);


        } else if (event.value == 'P') {

          this.formMovimento.itemOption('dati-generali-movimento.quantitaRespinta', 'disabled', false);
          this.formMovimento.formRefreshInputData('quantitaRespinta', null);
          this.formMovimento.formRefreshInputData('idMotivoRespinta', null);
          this.formMovimento.formRefreshInputData('descrizioneRespinta', null);

          this.formMovimento.itemOption('dati-generali-movimento.quantitaRespinta', 'disabled', true);
          this.formMovimento.itemOption('dati-generali-movimento.idMotivoRespinta', 'disabled', true);

        } else if (event.value == 'A') {


          this.formMovimento.formRefreshInputData('quantitaRespinta', null);
          this.formMovimento.formRefreshInputData('idMotivoRespinta', null);
          this.formMovimento.formRefreshInputData('descrizioneRespinta', null);

          this.formMovimento.itemOption('dati-generali-movimento.quantitaRespinta', 'disabled', true);
          this.formMovimento.itemOption('dati-generali-movimento.idMotivoRespinta', 'disabled', true);


        }

      }

      if (event.campo.dataField == "idMotivoRespinta") {
        if (event.value == 4) {
          setTimeout(() => {
            this.formMovimento.itemOption('dati-generali-movimento.descrizioneRespinta', 'disabled', false);

            this.formMovimento.getEditor('descrizioneRespinta').focus()
          }, 300);
        } else {
          setTimeout(() => {
            this.formMovimento.itemOption('dati-generali-movimento.descrizioneRespinta', 'disabled', true);
            this.formMovimento.formRefreshInputData('descrizioneRespinta', null)
          }, 300);
        }
      }
    }

    if (event.name == "onValueChanged") {

      const component = event.masterComponent as NewNicaFormComponent;

      if (event.campo.dataField === 'numeroColli') {
        console.log(event)
        component.itemOption('dati-generali-movimento.rinfusa', 'disabled', event.value !== null && event.value !== '')
        component.formRefreshInputData('rinfusa', false)
      }
      if (event.campo.dataField === 'rinfusa') {
        console.log(event)
        component.itemOption('dati-generali-movimento.numeroColli', 'disabled', event.value)
        component.formRefreshInputData('numeroColli', null)
      }

      if (event.campo.dataField === "cantiere_Descrizione") {

        const idCantiere = event.formData.idCantiereFuoriUl || false
        if (idCantiere) {
          const queryList: QueryList<NicaDataGridComponent> = event.masterComponent.dataGridForm
          const dataGrid: NicaDataGridComponent = queryList.last
          dataGrid.dataJson['idCantiereFuoriUl'] = idCantiere
          const queryString: string[] = dataGrid.queryString.split('&')
          for (let i = 0; i < queryString.length; i++) {
            if (queryString[i].startsWith('idCantiereFuoriUL=')) {
              queryString[i] = `idCantiereFuoriUL=${idCantiere}`;
            }
          }
          dataGrid.queryString = queryString.join('&');
          dataGrid.refresh()
        }
      }
      if (event.campo.dataField === "produttore_Descrizione_Sede") {

        const idProduttore = event.formData.idProduttore || false
        if (idProduttore) {
          const queryList: QueryList<NicaDataGridComponent> = event.masterComponent.dataGridForm
          const dataGrid: NicaDataGridComponent = queryList.last
          dataGrid.dataJson['idProduttore'] = idProduttore
          const queryString: string[] = dataGrid.queryString.split('&')
          for (let i = 0; i < queryString.length; i++) {
            if (queryString[i].startsWith('idProduttoreSede=')) {
              queryString[i] = `idProduttoreSede=${idProduttore}`;
            }
          }
          dataGrid.queryString = queryString.join('&');
          dataGrid.refresh()
        }
      }

      if (event.campo.dataField == 'produttore_Descrizione_Soggetto' && this.apiset == 'DocumentoRifiuti') {
        const idOperazione = this.filterID['causale_Id_Operazione']
        const isSpurghi = event.formData.spurghi
        if ((idOperazione == 'C1' || idOperazione == 'A4' || idOperazione == 'A5') && isSpurghi) {
          if (event.formData.produttore_Id_Soggetto === event.formData.trasportatore_Id_Soggetto) {
            this.formMovimento.itemOption('dati-generali-movimento.addDatiRitiri', 'disabled', false);
          } else {
            event.formData.listaInterventiSpurghi = []
            this.formMovimento.itemOption('dati-generali-movimento.addDatiRitiri', 'disabled', true);
          }
        }
      }

      if (event.campo.dataField == 'produttore_Descrizione_Soggetto') {
        let nsAzienda = event.formData.aziendaProduttore
        // this.formMovimento.itemOption('dati-generali-movimento.autorizzazioneProduttore_Descrizione_Full', 'disabled', !nsAzienda);
        this.formMovimento.itemOption('dati-generali-movimento.autorizzazioneProduttoreArea_Descrizione', 'disabled', !nsAzienda);
        this.formMovimento.itemOption('dati-generali-movimento.cantiere_Descrizione', 'disabled', !nsAzienda);
        this.formMovimento.itemOption('dati-generali-movimento.magazzinoProduttore_Descrizione', 'disabled', !nsAzienda);

        if (!nsAzienda) {
          // this.formMovimento.formRefreshInputData('autorizzazioneProduttore_Descrizione_Full',null)
          this.formMovimento.formRefreshInputData('autorizzazioneProduttoreArea_Descrizione', null)
          this.formMovimento.formRefreshInputData('cantiere_Descrizione', null)
          this.formMovimento.formRefreshInputData('magazzinoProduttore_Descrizione', null)
        }
        this.formMovimento.formRefreshInputData('idProduttoreAlboCategoria ', null);
        this.formMovimento.formRefreshInputData('produttoreAlboCategoria_Descrizione_Full', null)
        this.formMovimento.formRefreshInputData('autorizzazioneProduttore_Descrizione_Full ', null);
        this.formMovimento.formRefreshInputData('idAutorizzazioneProduttore', null)
      }


      if (event.campo.dataField == 'destinatario_Descrizione_Soggetto') {
        let nsAzienda = event.formData.aziendaDestinatario
        // this.formMovimento.itemOption('dati-generali-movimento.autorizzazioneDestinatario_Descrizione_Full', 'disabled', !nsAzienda);
        this.formMovimento.itemOption('dati-generali-movimento.magazzinoDestinatario_Descrizione', 'disabled', !nsAzienda);
        this.formMovimento.itemOption('dati-generali-movimento.autorizzazioneDestinatarioArea_Full', 'disabled', !nsAzienda);

        if (!nsAzienda) {
          // this.formMovimento.formRefreshInputData('autorizzazioneDestinatario_Descrizione_Full',null)
          this.formMovimento.formRefreshInputData('magazzinoDestinatario_Descrizione', null)
          this.formMovimento.formRefreshInputData('autorizzazioneDestinatarioArea_Full', null)
        }
      }

      if (event.campo.dataField == 'eer') {
        if (event.value && event.value.endsWith('99')) {
          this.disableCerDesc = false;
        }
        else {
          this.disableCerDesc = true;
          event.formData.descrizioneAssegnata = null
          event.masterComponent.dataSet.descrizioneAssegnata = null
          this.formMovimento.formRefreshInputData('altriDatiRifiuto.descrizioneAssegnata', null);
        }

      }

      if (event.campo.dataField == 'quantitaOrigineKg') {

        if (event.formData.tipoAccettazione == 'R') {
          this.formMovimento.formRefreshInputData('quantitaRespinta', event.value)
        }
      }

      if (event.campo.dataField == 'quantitaKg') {
        const peso = event.value;
        if (!this.calcolaVolumePeso) {
          this.calcolaVolumePeso = this.formMovimento.dataSet.calcolaVolumePeso
        }
        if (this.calcolaVolumePeso == 'P') {
          if (!this.pesoSpecificoKGMC) {
            this.pesoSpecificoKGMC = this.formMovimento.dataSet.pesoSpecificoKGMC
          }
          const pesoSpecifico = parseInt(this.pesoSpecificoKGMC)
          let volume = peso / pesoSpecifico;
          this.formMovimento.formRefreshInputData('volume', volume);
          this.formMovimento.formRefreshInputData('unitaMisuraVolume', 'M');

        }

        if (event.formData.kgTaraPesa) {

          let lordo = peso + event.formData.kgTaraPesa;
          this.formMovimento.formRefreshInputData('kgLordoPesa', lordo);

        }

      }
      if (event.campo.dataField == 'quantitaOrigineKg' && this.apiset == 'DocumentoRifiuti') {
        const peso = event.value;
        //const peso = event.value.split(',')[0]; 
        if (!this.calcolaVolumePeso) {
          this.calcolaVolumePeso = this.formMovimento.dataSet.calcolaVolumePeso
        }
        if (this.calcolaVolumePeso == 'P') {
          if (!this.pesoSpecificoKGMC) {
            this.pesoSpecificoKGMC = this.formMovimento.dataSet.pesoSpecificoKGMC
          }
          const pesoSpecifico = parseInt(this.pesoSpecificoKGMC)
          let volume = peso / pesoSpecifico;

          this.formMovimento.formRefreshInputData('volume', Number(volume).toFixed(3));
          this.formMovimento.formRefreshInputData('unitaMisuraVolume', 'M');

        }

        if (event.formData.kgTaraPesa) {

          let lordo = peso + event.formData.kgTaraPesa;
          this.formMovimento.formRefreshInputData('kgLordoPesa', lordo);

        }

      }

      if (event.campo.dataField.volume) {

        const volume = event.campo.dataField.volume;

        if (this.calcolaVolumePeso == 'V') {
          if (!this.pesoSpecificoKGMC) {
            this.pesoSpecificoKGMC = this.formMovimento.dataSet.pesoSpecificoKGMC
          }
          const pesoSpecifico = parseInt(this.pesoSpecificoKGMC)
          let volumeC = volume * pesoSpecifico;
          if (this.apiset == 'DocumentoRifiuti') {
            this.formMovimento.formRefreshInputData('quantitaOrigineKg', Number(volumeC).toFixed(3));
          } else {
            this.formMovimento.formRefreshInputData('quantitaKg', Number(volumeC).toFixed(3));
          }

          this.formMovimento.formRefreshInputData('unitaMisuraVolume', 'M')


        }

      }

      if (event.campo.dataField == 'produttore_Descrizione_Full' && !event.value || event.campo.dataField == 'produttore_Descrizione_Full' && event.value != event.previousValue) {
        if (!event.previousValue) {
          return
        }
        if (!event.value) {
          this.formMovimento.formRefreshInputData('idProduttore', null)
        }
        this.formMovimento.formRefreshInputData('Detentore', null);

        this.formMovimento.formRefreshInputData('idAutorizzazioneProduttore', null);
        this.formMovimento.formRefreshInputData('autorizzazioneProduttore_Descrizione_Full', null);
        this.formMovimento.formRefreshInputData('idProduttoreAlboCategoria', null);
        this.formMovimento.formRefreshInputData('produttoreAlboCategoria_Descrizione_Full', null);
        this.formMovimento.formRefreshInputData('cantiere_Descrizione', null);
      }



      if (event.campo.dataField == 'trasportatore_Descrizione_Full' && !event.value || event.campo.dataField == 'trasportatore_Descrizione_Full' && event.value != event.previousValue
      ) {
        if (!event.previousValue) {

          const numeroIscrizioneAlboT = event.formData.trasportatore_NumDataIscrizioneAlbo;
          let dataIscrizioneAlboT = ''
          if (event.formData.dataIscrizioneAlboT) {
            dataIscrizioneAlboT = ' - ' + this.dateParseIT(event.formData.dataIscrizioneAlboT);
          }

          let nIscT = numeroIscrizioneAlboT + dataIscrizioneAlboT

          this.formMovimento.formRefreshInputData('autorizzazioneTrasportatoreAlbo_Full', nIscT)

          return
        }

        if (!event.value) {
          this.formMovimento.formRefreshInputData('idTrasportatore', null);
          this.formMovimento.formRefreshInputData('autorizzazioneTrasportatoreAlbo_Full', '');
          this.formMovimento.formRefreshInputData('dataIscrizioneAlboT', null);
          this.formMovimento.formRefreshInputData('numeroIscrizioneAlboT', null);

        }

        this.formMovimento.formRefreshInputData('idTrasportatoreAlboCategoria', null)

        this.formMovimento.formRefreshInputData('autorizzazioneTrasportatoreAlbo_Full', null)
        this.formMovimento.formRefreshInputData('idAutista', null)
        this.formMovimento.formRefreshInputData('autista_Cognome_Nome', null)
        this.formMovimento.formRefreshInputData('automezzo_Descrizione_Full', null)
        this.formMovimento.formRefreshInputData('carrozzeriemobiliautomezzo', null)
        this.formMovimento.formRefreshInputData('rimorchio_Descrizione', null)
        this.formMovimento.formRefreshInputData('idAutomezzo', null)
        this.formMovimento.formRefreshInputData('idRimorchio', null)
        this.formMovimento.formRefreshInputData('dataIscrizioneAlboT', null);
        this.formMovimento.formRefreshInputData('numeroIscrizioneAlboT', null);
      }

      if (event.campo.dataField == "descrizione_Operatore_1") {

        if (!event.formData.idOperatore1 || !event.formData.idOperatore2) {
          return
        }
        if (event.formData.idOperatore1 == event.formData.idOperatore2) {

          alert('Operatore già utilizzato', 'Attenzione!')
          this.formMovimento.formRefreshInputData('idOperatore1', null)
          this.formMovimento.formRefreshInputData('descrizione_Operatore_1', null)
        }




      }

      if (event.campo.dataField == "descrizione_Operatore_2") {
        if (!event.formData.idOperatore1 || !event.formData.idOperatore2) {
          return
        }

        if (event.formData.idOperatore2 == event.formData.idOperatore1) {

          alert('Operatore già utilizzato', 'Attenzione!')
          this.formMovimento.formRefreshInputData('idOperatore2', null)
          this.formMovimento.formRefreshInputData('descrizione_Operatore_2', null)

        }

      }

      if (event.campo.dataField == 'destinatario_Descrizione_Full' && event.value) {
        if (event.formData.idDestinatario) {
          let idDestinatario = event.formData.idDestinatario;

          this.anagraficaService.getElenco('Autorizzazione', idDestinatario, '').then(resAuto => {
            if (resAuto['items'].length == 1) {

              let idAutorizzazioneDestinatario = resAuto['items'][0].id
              this.formMovimento.formRefreshInputData('idAutorizzazioneDestinatario', idAutorizzazioneDestinatario);

              let dataRilascio = ''
              if (resAuto['items'][0]['dataRilascio']) {
                dataRilascio = this.dateParseIT(resAuto['items'][0]['dataRilascio'])
              }

              let numero = ''

              if (resAuto['items'][0]['numero']) {
                numero = resAuto['items'][0]['numero'] + ' - '
              }

              let descAutorizzazione = numero + dataRilascio

              this.formMovimento.formRefreshInputData('autorizzazioneDestinatario_Descrizione_Full', descAutorizzazione);

            }
          })
        }

      }

      if (event.campo.dataField == 'destinatario_Descrizione_Full' && !event.value || event.campo.dataField == 'destinatario_Descrizione_Full' && event.value != event.previousValue) {
        if (!event.previousValue) {

          return
        }
        if (!event.value) {
          this.formMovimento.formRefreshInputData('idDestinatario', null)
        }

        this.formMovimento.formRefreshInputData('idAutorizzazioneDestinatario', null);

        this.formMovimento.formRefreshInputData('autorizzazioneDestinatario_Descrizione_Full', null);
        this.formMovimento.formRefreshInputData('idAutorizzazioneDestinatarioArea', null);
        this.formMovimento.formRefreshInputData('autorizzazioneDestinatarioArea_Full', null);
        this.formMovimento.formRefreshInputData('idMagazzinoDestinatario', null);
        this.formMovimento.formRefreshInputData('magazzinoDestinatario_Descrizione', null);
        this.formMovimento.formRefreshInputData('idOperazioneRD', null);
      }

      if (event.campo.dataField == 'intermediario_Descrizione_Full' && !event.value || event.campo.dataField == 'intermediario_Descrizione_Full' && event.value != event.previousValue) {
        if (!event.previousValue) {
          let numeroIscrizioneAlboI = ''

          if (event.formData.autorizzazioneIntermediarioAlbo) {
            numeroIscrizioneAlboI = event.formData.autorizzazioneIntermediarioAlbo;
          }


          let dataIscrizioneAlboI = ''
          if (event.formData.dataIscrizioneAlboI) {
            dataIscrizioneAlboI = ' - ' + this.dateParseIT(event.formData.dataIscrizioneAlboI);
          }


          this.formMovimento.formRefreshInputData('autorizzazioneIntermediarioAlbo_Full', numeroIscrizioneAlboI + dataIscrizioneAlboI)

          return
        }
        if (!event.value) {
          this.formMovimento.formRefreshInputData('idIntermediario', null)
        }
        this.formMovimento.formRefreshInputData('idIntermediarioCategoriaAlbo', null);
        this.formMovimento.formRefreshInputData('autorizzazioneIntermediarioAlbo_Full', null);
        this.formMovimento.formRefreshInputData('autorizzazioneIntermediarioAlbo', null);
        this.formMovimento.formRefreshInputData('dataIscrizioneAlboI', null);
      }

      if (event.campo.dataField == 'destinatario_Descrizione_Full' && event.value) {
        if (event.formData.idDestinatario) {
          let idDestinatario = event.formData.idDestinatario;

          this.anagraficaService.getElenco('Autorizzazione', idDestinatario, '').then(resAuto => {
            if (resAuto['items'].length == 1) {

              let idAutorizzazioneDestinatario = resAuto['items'][0].id
              this.formMovimento.formRefreshInputData('idAutorizzazioneDestinatario', idAutorizzazioneDestinatario);

              let dataRilascio = ''
              if (resAuto['items'][0]['dataRilascio']) {
                dataRilascio = this.dateParseIT(resAuto['items'][0]['dataRilascio'])
              }

              let numero = ''

              if (resAuto['items'][0]['numero']) {
                numero = resAuto['items'][0]['numero'] + ' - '
              }

              let descAutorizzazione = numero + dataRilascio

              this.formMovimento.formRefreshInputData('autorizzazioneDestinatario_Descrizione_Full', descAutorizzazione);

            }
          })
        }

      }

      if (event.campo.dataField == 'produttoreAlboCategoria_Descrizione_Full') {
        if (event.value) {
          if (event.value != this.formMovimento.dataSet['idProduttoreAlboCategoria']) {
            return
          }
          //masterComponent.itemOption('dati-generali-movimento.produttoreAlboCategoria_Descrizione_Full', 'disabled',true);
          this.formMovimento.itemOption('dati-generali-movimento.autorizzazioneProduttore_Descrizione_Full', 'disabled', true)
          this.formMovimento.itemOption('dati-generali-movimento.autorizzazioneProduttoreArea_Descrizione', 'disabled', true)
          this.formMovimento.formRefreshInputData('idAutorizzazioneProduttore', null);
          this.formMovimento.formRefreshInputData('autorizzazioneProduttore_Descrizione_Full', null)
          this.formMovimento.formRefreshInputData('autorizzazioneProduttoreArea_Descrizione', null)

          let dataAuto = ''
          let autorizzazioneProduttore_Numero = event.formData.autorizzazioneProduttore_Numero + ' - '
          if (event.formData.dataInizioCategoriaAlboGestoreProd) {
            dataAuto = this.dateParseIT(event.formData.dataInizioCategoriaAlboGestoreProd)
          }
          if (!event.formData.autorizzazioneProduttore_Numero) {
            //alert('Numero iscrizione Albo mancante','Attenzione!')
            autorizzazioneProduttore_Numero = ''

          }
          if (event.formData.produttore_NumDataIscrizioneAlbo) {

            autorizzazioneProduttore_Numero = event.formData.produttore_NumDataIscrizioneAlbo + ' - '

          }

          this.anagraficaService.getValue('CategoriaAlboGestore', event.formData.idCategoriaAlboGestoreP, '').then(res => {

            const descCatNum = autorizzazioneProduttore_Numero + dataAuto + ' ' + res['descrizione'];

            console.log('produttoreAlboCategoria_Descrizione_Full', descCatNum);

            this.formMovimento.formRefreshInputData('produttoreAlboCategoria_Descrizione_Full', descCatNum)

          })


        } else {
          this.formMovimento.itemOption('dati-generali-movimento.autorizzazioneProduttore_Descrizione_Full', 'disabled', false)
          this.formMovimento.itemOption('dati-generali-movimento.autorizzazioneProduttoreArea_Descrizione', 'disabled', false)
          this.formMovimento.formRefreshInputData('produttoreAlboCategoria_Descrizione_Full', null)
        }


      }

      if (event.campo.dataField == 'autorizzazioneProduttore_Descrizione_Full') {
        let nsAzienda = typeof event.formData.aziendaProduttore === 'boolean' ? event.formData.aziendaProduttore : true
        this.formMovimento.itemOption('dati-generali-movimento.autorizzazioneProduttoreArea_Descrizione', 'disabled', !nsAzienda);
        this.formMovimento.itemOption('dati-generali-movimento.cantiere_Descrizione', 'disabled', !nsAzienda);
        this.formMovimento.itemOption('dati-generali-movimento.magazzinoProduttore_Descrizione', 'disabled', !nsAzienda);
        if (event.value) {
          //masterComponent.itemOption('dati-generali-movimento.produttoreAlboCategoria_Descrizione_Full', 'disabled',true);
          this.formMovimento.itemOption('dati-generali-movimento.produttoreAlboCategoria_Descrizione_Full', 'disabled', true);
          this.formMovimento.formRefreshInputData('idProduttoreAlboCategoria', null);
          this.formMovimento.formRefreshInputData('produttoreAlboCategoria_Descrizione_Full', null)
          this.formMovimento.formRefreshInputData('autorizzazioneProduttore_Numero', null)
          this.formMovimento.formRefreshInputData('produttoreAlboCategoria_Descrizione_Full', null)

        } else {
          this.formMovimento.itemOption('dati-generali-movimento.produttoreAlboCategoria_Descrizione_Full', 'disabled', false)

        }


      }

      if (event.campo.dataField == 'autorizzazioneTrasportatoreAlbo_Full') {
        if (event.value) {

          if (event.value != this.formMovimento.dataSet['idTrasportatoreAlboCategoria']) {
            return
          }

          let data = ''

          if (event.formData.dataInizioCategoriaAlboGestoreTras) {
            data = this.dateParseIT(event.formData.dataInizioCategoriaAlboGestoreTras) + ' - '
          }

          let autorizzazioneTrasportatore_Numero = event.formData.numeroIscrizioneAlboT //event.formData.trasportatore_NumDataIscrizioneAlbo + ' - '

          if (event.formData.trasportatore_NumDataIscrizioneAlbo) {
            //alert('Numero iscrizione Albo mancante','Attenzione!')
            autorizzazioneTrasportatore_Numero = event.formData.trasportatore_NumDataIscrizioneAlbo
          }
          let isMatch = false
          if (autorizzazioneTrasportatore_Numero) {
            var dateType = /\d{1,2}\/\d{1,2}\/\d{2,4}/;
            isMatch = dateType.test(autorizzazioneTrasportatore_Numero);

            if (isMatch) {
              data = ''
            }

          }

          this.anagraficaService.getValue('CategoriaAlboGestore', event.formData.idCategoriaAlboGestoreT, '').then(res => {
            //this.formMovimento.formRefreshInputData('descCategoriaAlboTrasportatore','')
            const descCatNumTrasp = autorizzazioneTrasportatore_Numero + ' - ' + data + res['descrizione'];


            this.formMovimento.formRefreshInputData('autorizzazioneTrasportatoreAlbo_Full', descCatNumTrasp)

          })


        }


      }

      if (event.campo.dataField == 'autorizzazioneIntermediarioAlbo_Full') {
        if (event.value) {

          if (event.value != this.formMovimento.dataSet['idIntermediarioAlboCategoria']) {
            return
          }

          let data = ''

          if (event.formData.dataIscrizioneAlboI) {
            data = this.dateParseIT(event.formData.dataIscrizioneAlboI)
          }

          let autorizzazioneIntermediarioAlbo = event.formData.autorizzazioneIntermediarioAlbo + ' - '

          if (!event.formData.autorizzazioneIntermediarioAlbo) {
            //alert('Numero iscrizione Albo mancante','Attenzione!')
            autorizzazioneIntermediarioAlbo = ''
          }

          this.anagraficaService.getValue('CategoriaAlboGestore', event.formData.idCategoriaAlboGestoreI, '').then(res => {
            //this.formMovimento.formRefreshInputData('descCategoriaAlboTrasportatore','')
            const descCatNumTrasp = autorizzazioneIntermediarioAlbo + data + ' - ' + res['descrizione'];


            this.formMovimento.formRefreshInputData('autorizzazioneIntermediarioAlbo_Full', descCatNumTrasp)

          })


        }

      }

      if (event.campo.dataField == 'automezzo_Descrizione_Full') {
        if (event.value) {
          const queryAutomezzo = '?idAutomezzo=' + event.formData.idAutomezzo

          const api = this.apiset + '/GetElencoCarrozzeriaByAutomezzo';

          this.anagraficaService.getValue(api, '', queryAutomezzo).then(descCatNumTrasp => {

            if (descCatNumTrasp) {
              this.formMovimento.formRefreshInputData('carrozzeriemobiliautomezzo', descCatNumTrasp['descrMessage'])
            }



          })

        }
      }

      if (event.campo.dataField == 'rimorchio_Descrizione') {
        if (event.value) {
          const queryAutomezzo = '?idAutomezzo=' + event.formData.idRimorchio

          const api = this.apiset + '/GetElencoCarrozzeriaByAutomezzo';

          this.anagraficaService.getValue(api, '', queryAutomezzo).then(descCatNumTrasp => {

            if (descCatNumTrasp) {
              this.formMovimento.formRefreshInputData('carrozzerieMobiliRimorchio', descCatNumTrasp['descrMessage'])
            }



          })

        }
      }


      if (event.campo.dataField == 'eer') {
        console.log('eer', event)

        // if (!event.formData.eer.endsWith("99")) {
        //   console.log(event.formData)
        //   event.formData.descrizioneAssegnata = null
        //   event.masterComponent.dataSet.descrizioneAssegnata = null
        //   this.formMovimento.formRefreshInputData('altriDatiRifiuto.descrizioneAssegnata', null);
        //   console.log(event.formData)

        // }

        const isCerPericoloso = event.formData.isCerPericoloso;

        if (isCerPericoloso) {


          let validationRules = [{
            type: 'required',
            message: 'Caratteristiche di pericolo obbligatorie'
          }]

          this.formMovimento.itemOption('dati-generali-movimento.listaHP', 'validationRules', validationRules);

        } else {
          this.formMovimento.itemOption('dati-generali-movimento.listaHP', 'validationRules', null);
        }


      }



      if (this.isEnabeldSessionStorage) {
        if (event.value) {
          let myformData = event.formData;
          delete myformData[""];
          sessionStorage.setItem(this.apiset, JSON.stringify(myformData))
        }

      }
    }

    if (event.name == 'beforeMitter') {

      if (event.campo.dataField == "produttore_Descrizione_Sede") {
        let produttore_Id_Soggetto = event.formData.produttore_Id_Soggetto;

        if (!produttore_Id_Soggetto) {
          alert("Selezionare prima l'azienda", 'Attenzione!')
          event.cancel = true
        }
      }

      if (event.campo.dataField == "destinatario_Descrizione_Sede") {
        let destinatario_Id_Soggetto = event.formData.destinatario_Id_Soggetto;

        if (!destinatario_Id_Soggetto) {
          alert("Selezionare prima l'azienda", 'Attenzione!')
          event.cancel = true
        }
      }


      if (event.campo.dataField == "trasportatore_Descrizione_Soggetto") {
        const trasporto = event.formData.causale_Trasporto;
        if (trasporto === 'X') {
          event.campo.dynamic.queryString = '?TipoAttivita=T';

        } else {
          event.campo.dynamic.queryString = '?NostreAziende=N&TipoAttivita=T';
        }

      }

      if (event.campo.dataField == "trasportatore_Descrizione_Sede") {
        let trasportatore_Id_Soggetto = event.formData.trasportatore_Id_Soggetto;

        if (!trasportatore_Id_Soggetto) {
          alert("Selezionare prima l'azienda", 'Attenzione!')
          event.cancel = true
        }
      }

      if (event.campo.dataField == "intermediario_Descrizione_Sede") {
        let intermediario_Id_Soggetto = event.formData.intermediario_Id_Soggetto;

        if (!intermediario_Id_Soggetto) {
          alert("Selezionare prima l'azienda", 'Attenzione!')
          event.cancel = true
        }
      }

      if (event.campo.dataField == "produttoreAlboCategoria_Descrizione_Full") {

        let idProduttore = event.formData.idProduttore;

        if (!idProduttore) {

          alert("Selezionare prima il produttore", 'Attenzione!');
          event.cancel = true
          return event


        }

        // let produttore_NumDataIscrizioneAlbo = event.formData.produttore_NumDataIscrizioneAlbo

        // if (!produttore_NumDataIscrizioneAlbo) {
        //   alert("Produttore non è iscritto all' albo gestori ambientali", 'Attenzione!');
        //   event.cancel = true
        //   return event
        // }

      }

      if (event.campo.dataField == "autorizzazioneTrasportatoreAlbo_Full") {
        let idTrasportatore = event.formData.idTrasportatore;

        if (!idTrasportatore) {
          alert("Selezionare prima il trasportatore", 'Attenzione!');
          event.cancel = true
          return event
          return
        }

        let trasportatore_NumDataIscrizioneAlbo = event.formData.trasportatore_NumDataIscrizioneAlbo
        let numeroIscrizioneAlboT = event.formData.numeroIscrizioneAlboT

        if (!trasportatore_NumDataIscrizioneAlbo) {
          alert("Trasportatore non è iscritto all' albo gestori ambientali", 'Attenzione!');
          event.cancel = true
          return event
        }

      }

      if (event.campo.dataField == "autorizzazioneIntermediarioAlbo_Full") {

        let idIntermediario = event.formData.idIntermediario;

        if (!idIntermediario) {
          alert("Selezionare prima l'intermediario", 'Attenzione!');
          event.cancel = true
          return event
          return
        }

        let iscrizioneAlboIntermediarioAlbo = event.formData.iscrizioneAlboIntermediarioAlbo

        if (!iscrizioneAlboIntermediarioAlbo) {
          alert("L'intermediario non è iscritto all' albo gestori ambientali", 'Attenzione!');
          event.cancel = true
          return event
        }

      }

      if (event.campo.dataField == "testoADR_Descrizione") {



        if (event.formData.eer) {
          let eer = event.formData.eer
          event.campo.dynamic.filterStatic = `?$filter=( eer eq '${eer}' )`
          return event;


        } else {
          event.cancel = true;
          alert('Selezionare codice EER', 'Attenzione!')
          return event;
        }




        //queryStringFilter

      }
    }

    if (event.name == "formFromComponentSaved") {
      this.loader.show()
      let result = this.userComponentService.destroyCurrentOpenPopUpByGuid(event.guid)


      if (result) {
        let eventData = {
          campo: event.campo,
          data: event.data,
          detailRif: [
            {
              api: 'sede',
              service: 'sede',
              componentName: 'AnaUnitaLocaliComponent',
            }
          ]

        }



        //this.editorSoggettiByMovimento(eventData, false);

      }



      return event;

    }

  }

  formDataGridEventMovDoc(event) {
    console.log('formDataGridEventMovDoc', event)
    if (event.name == 'onRowExpandedDataGrid') {
      if (event.campo.dataField == 'produttore_Descrizione_Soggetto' || event.campo.dataField == 'destinatario_Descrizione_Soggetto' || event.campo.dataField == 'trasportatore_Descrizione_Soggetto' || event.campo.dataField == 'intermediario_Descrizione_Soggetto') {
        if (typeof event.expandedData != 'undefined') {
          if (event.expandedData.length == 1) {

            let data = event.expandedData[0]
            this.formMovimento.updateFiedlFromGridSelection(data, event.campo);
            this.userComponentService.destroyCurrentOpenPopUpByGuid(event.guid)

          }
        }
      }

    }

    if (event.name == 'toolbarButtonClick') {
      const GrigliaComponent = event.dataGridComponent

      if (event.buttonEvents == 25) {
        this.openEditorSoggetti(event);


        /* let api = 'soggetto';
        let service = 'soggetto';
        let template = "grid";

        let querystring =
        {
          NostreAziende: 'N',
          TipoAttivita: 'P'
        }
        let dataFilter = {
          nsAzienda: false,
          NostreAziende: 'N',
          TipoAttivita: 'P'
        }




        let data = [{
          api: api,
          service: service,
          titolo: '',
          breadcrumb: '',
          currentTabId: 'AnaSoggettoComponent',
          currentTabName: 'AnaSoggettoComponent',
          
          data: JSON.stringify(dataFilter),
          filter: JSON.stringify(dataFilter),
          helpDoc: null,
          componentName: 'AnaSoggettoComponent',
          templateView: template,
          descEvent: ''
        }]



        let guid = this.openComponentInPopUP('AnaSoggettoComponent', data,null ,null, '',false,false,'bottom');

        this.userComponentService.outputComponent.subscribe(currentOutput => {
          if(currentOutput.guid == guid){

            console.log('currentOutputReturn-->',currentOutput);
            if(currentOutput.name == "closeTab" ){
             
              GrigliaComponent.refresh()
                
            }

          }
          
        }) */

      }
    }
  }

  formButtonsEventMovDOc(event) {
    if (event.name == "viewRegistri") {

      let data = this.formMovimento.dataSet;

      let dataInputRegistri = []
      dataInputRegistri.push(
        {
          tipoRegistro: 'Carico',
          registro_Descrizione: data.registro_Descrizione_Carico
        },

      )

      dataInputRegistri.push(
        {
          tipoRegistro: 'Scarico',
          registro_Descrizione: data.registro_Descrizione_Scarico
        },

      )
      dataInputRegistri.push(
        {
          tipoRegistro: 'Trasporto',
          registro_Descrizione: data.registro_Descrizione_Trasporto
        },

      )
      dataInputRegistri.push(
        {
          tipoRegistro: 'Intermediazione',
          registro_Descrizione: data.registro_Descrizione_Intermediazione
        },

      )


      let registriPanel = [

        {
          componentData: registriPanelMovimenti,
          apiSource: '',
          componentType: 'dynamicGrid',
          filterKey: '',
          height: 210,
          width: 490,
          dataInput: dataInputRegistri,
          dataForm: null

        }
      ]


      let title = 'Registri Movimento '

      this.openComponentInPopUP('NicaDynamicContentComponent', registriPanel, '210', '490', title, true)
      return




    }


    if (event.event == "addDati") {


      const formButton = [{

        location: "after",
        widget: "dxButton",
        locateInMenu: "never",
        stylingMode: 'text',
        text: 'Conferma',
        icon: "glyphicon icon-salva-form",
        event: 'formConferma'


      },
      {

        location: "after",
        widget: "dxButton",
        locateInMenu: "never",
        stylingMode: 'text',
        text: 'Annulla',
        icon: "glyphicon icon-annulla-form",
        event: 'formAnnulla'


      }
      ]

      let formData;
      if (typeof this.formMovimento != 'undefined') {

        formData = this.formMovimento.dataSet
      } else {

        formData = event.data

      }




      switch (event.name) {
        case "addDatiRitiri":
          let dataRitiri = {
            SubjectCall: 'RitiriGrid',
            returnDatafield: 'listaInterventiSpurghi',
            listaAltriSoggetti: formData.listaInterventiSpurghi,
            isPopUp: true,
            data: formData,
            tastiBottom: [22, 23]
          }

          this.formPanelAltriSoggetti(dataRitiri, 'ritiri', 'Gestione Ritiri');
          break;
        case "addDatiRifiuto":
          if (!formData.eer) {
            alert('Seleziona prima il codice EER', 'Attenzione');
            return
          }
          const formDatiRifiuto = {
            eer: formData.eer,
            descrizioneAssegnata: this.disableCerDesc ? null : formData.descrizioneAssegnata,
            idRecup: formData.idRecup,
            idBasilea: formData.idBasilea,
            analisiNumero: formData.analisiNumero,
            analisiData: formData.analisiData,
            analisiScadenza: formData.analisiScadenza,
            tipoAnalisi: formData.tipoAnalisi,
            bod: formData.bod,
            cod: formData.cod
          }
          let dataToSend =
          {
            service: 'altriDatiRifiuto',
            api: '',
            filterKey: '',
            queryString: '',
            remoteOperation: false,
            dataJson: formDatiRifiuto,

            type: 'simple',
            nCol: 1,

            toolbarTop: false,
            toolbarBottom: true,
            heightForm: 533,

            ngClass: 'atri-dati-form',

          }

          this.openEditorAltri(dataToSend, 'Altri Dati relativi al rifiuto', 600, 1000)


          break;
        case "addDatiFormulario":

          const formDatiFormulario = {
            percorso: formData.percorso,
            appunti: formData.appunti,
            tipoFormulario: formData.tipoFormulario,
            idTipoFormulario: formData.idTipoFormulario,
          }

          let dataToSendF =
          {
            service: 'altriDatiFormulario',
            api: '',
            filterKey: '',
            queryString: '',
            dataJson: formDatiFormulario,
            type: 'simple',
            nCol: 1,
            remoteOperation: false,

            toolbarTop: false,
            toolbarBottom: true,
            heightForm: 333,
            labelWidth: 125,
            ngClass: 'atri-dati-form',

          }

          this.openEditorAltri(dataToSendF, 'Altri Dati relativi al formulario', 400, 800)


          break;

        case "addDatiPesata":

          const formDatiPesata = {
            kgLordoPesa: formData.kgLordoPesa,
            dataLordoPesa: formData.dataLordoPesa,
            oraLordoPesa: formData.oraLordoPesa,
            mpLordoPesa: formData.mpLordoPesa,
            kgTaraPesa: formData.kgTaraPesa,
            dataTaraPesa: formData.dataTaraPesa,
            oraTaraPesa: formData.oraTaraPesa,
            mpTaraPesa: formData.mpTaraPesa,
          }

          let dataToSendPesata =
          {
            service: 'altriDatiPesata',
            api: '',
            filterKey: '',
            queryString: '',
            dataJson: formDatiPesata,
            type: 'simple',
            nCol: 1,
            remoteOperation: false,
            toolbarTop: false,
            toolbarBottom: true,
            heightForm: 333,
            ngClass: 'atri-dati-form',

          }

          this.openEditorAltri(dataToSendPesata, 'Dati relativi alla pesata', 400)


          break;
        case "addElencoVettori":

          let dataVettori = {
            SubjectCall: 'listaSoggetti',
            returnDatafield: 'listaAltriSoggettiT',
            listaAltriSoggetti: formData.listaAltriSoggettiT,
            isPopUp: true,
            data: formData
          }

          this.formPanelAltriSoggetti(dataVettori, 'vettori', 'Gestione Vettori');


          break;
        case "addElencoIntermediari":

          let dataIntermediari = {
            SubjectCall: 'listaSoggetti',
            returnDatafield: 'listaAltriSoggettiI',
            listaAltriSoggetti: formData.listaAltriSoggettiI,
            data: formData
          }

          this.formPanelAltriSoggetti(dataIntermediari, 'intermediari', 'Gestione Intermediari');
          //this.openComponent('GestioneAltriSoggettiComponent', dataIntermediari, 'Gestione altri Intermediari', 800, 750, false)


          break;


        default:
          break;
      }
    }

    //gestione eventi da bottone

    if (event.name == 'addSchedaTecnica') {


      let data = this.formMovimento.dataSet;

      this.formPanelSchedaTecnica(data)


    }

    if (event.name == 'GiacenzeRifiuti') {



      let data = this.formMovimento.dataSet;

      this.formPanelGiacenze(data)
      return



    }

  }

  async getInfoSede(idSede, field) {
    if (!idSede) {
      return false
    }
    let produttoreSediQueryString = `?id=${idSede}`
    const datiSede = await this.anagraficaService.getValue('Sede', '', produttoreSediQueryString)

    if (field) {
      return datiSede[field]
    }
    return datiSede
  }

  setDataBySessionStorage(form): Promise<void> {

    return new Promise<void>((resolve, reject) => {
      try {
        if (sessionStorage.getItem(this.apiset)) {
          const MydataSet = JSON.parse(sessionStorage.getItem(this.apiset))
          form.dataSet = MydataSet;
          //const result = str.split(',')[0]; // "132"
          if (form.dataSet.quantitaOrigineKg !== null && typeof form.dataSet.quantitaOrigineKg === 'string')
            form.dataSet.quantitaOrigineKg = form.dataSet.quantitaOrigineKg.replace(",", ".");
          //form.dataSet.quantitaOrigineKg=12.45;          
        }
        resolve();
      } catch (error) {

        reject(error);
      }
    });
  }

  // Metodo per aggiornare i dati basati sull'output
  async updateDataBasedOnOutput(currentOutput, form): Promise<void> {
    if (currentOutput.name == 'returnCreatedData' && currentOutput.guid == this.tempGuid) {
      let rowData = {
        id: currentOutput.id
      };
      const queryString = this.queryStringByService(currentOutput.service, rowData, 'filterEditor');
      const api = currentOutput.api;
      const dataFields = currentOutput.accessoringData;
      const dataField = currentOutput.dataField;
      const singleDataFields = currentOutput.dataField;
      let apiS = '';

      if (!queryString) {
        return
      }

      if (singleDataFields === "produttore_Descrizione_Soggetto" || singleDataFields === "trasportatore_Descrizione_Soggetto" || singleDataFields === "destinatario_Descrizione_Soggetto" || singleDataFields === "intermediario_Descrizione_Soggetto") {
        try {

          //console.log('curr',currentOutput);

          if (!currentOutput.id)
            return;

          const path = 'Sede/GetSedeFirstOfAll';
          const res = await this.anagraficaService.getValue(path, '', `?idSoggetto=${currentOutput.id}`);

          //console.log(res)
          this.refreshDataSoggetti(res, dataField, form);
          return



          /* if (soggetto && soggetto['id']) {
            const filterKeySoggetto = soggetto['id'];
            let datas = soggetto;
            let apiS = 'Sede';
            const sedi = await this.anagraficaService.getElenco(apiS, filterKeySoggetto, '');
            if (Array.isArray(sedi) && sedi.length > 0) {
              const sede = sedi[0];
              dataFields.forEach((values, key) => {
                let arrayValue = values.split('|');
                if (arrayValue.length > 1) {
                  form.formRefreshInputData(arrayValue[1], sede[arrayValue[0]]);
                } else {
                  form.formRefreshInputData(values, sede[values]);
                }
              });
               
            }
          } */
        } catch (error) {
          console.error('Errore durante l\'aggiornamento del form:', error);
        }
      } else {
        try {
          const data = await this.anagraficaService.getValue(api, '', queryString);
          if (data) {
            dataFields.forEach((values, key) => {
              let arrayValue = values.split('|');
              if (arrayValue.length > 1) {
                form.formRefreshInputData(arrayValue[1], data[arrayValue[0]]);
              } else {
                form.formRefreshInputData(values, data[values]);
              }
            });
            this.userComponentService.destroyOutputComponent();
            this.tempGuid = null;
            if (this.isEnabeldSessionStorage) {
              let myformData = this.formAnagrafica.formData;
              delete myformData[""];
              sessionStorage.setItem(this.apiset, JSON.stringify(myformData))
            }
          }
        } catch (error) {
          console.error('Errore durante l\'aggiornamento del form:', error);
        }


      }
    }
  }

  /**Refresh data **/
  refreshDataSoggetti(data, dataField, form) {

    console.log('refreshSoggetti-->', dataField);
    console.log('refreshDataSoggetti-->', data);

    switch (dataField) {
      case 'produttore_Descrizione_Soggetto':

        form.formRefreshInputData('idProduttore', data.id)
        form.formRefreshInputData('produttore_Id_Soggetto', data.idSoggetto);
        form.formRefreshInputData('produttore_Descrizione_Sede', data.descrizione);
        form.formRefreshInputData('produttore_Descrizione_Soggetto', data.descrizioneSoggetto);

        if (data.autorizzazione && !data.numeroIscrizioneAlbo) {
          form.formRefreshInputData('idAutorizzazioneProduttore', data.autorizzazione.id);
          form.formRefreshInputData('autorizzazioneProduttore_Descrizione_Full', data.autorizzazione.numero);
        }

        if (data.autorizzazioneArea) {
          form.formRefreshInputData('idAutorizzazioneProduttoreArea', data.autorizzazioneArea.id);
          form.formRefreshInputData('autorizzazioneProduttore_Descrizione_Area', data.autorizzazioneArea.descrizioneArea);
        }

        if (data.numeroIscrizioneAlbo && data.alboCategoria) {
          form.formRefreshInputData('produttoreNumeroIscrizioneAlbo', data.numeroIscrizioneAlbo);
          form.formRefreshInputData('dataInizioCategoriaAlboGestoreProd', data.alboCategoria.dataInizio);
          form.formRefreshInputData('produttoreAlboCategoria_Descrizione_Full', data.alboCategoria.id);
        }
        /* if(Object.keys(data.magazzinoRifiuti).length>0){
          this.formMovimento.formRefreshInputData('magazzinoProduttore_Descrizione',data.numeroIscrizioneAlbo);
          this.formMovimento.formRefreshInputData('dataInizioCategoriaAlboGestoreProd',data.numeroIscrizioneAlbo.dataInizioCategoriaAlboGestoreProd);
          this.formMovimento.formRefreshInputData('produttoreAlboCategoria_Descrizione_Full',data.alboCategoria.id);
        } */

        break;
      case 'trasportatore_Descrizione_Soggetto':
        form.formRefreshInputData('idTrasportatore', data.id)
        form.formRefreshInputData('trasportatore_Id_Soggetto', data.idSoggetto);
        form.formRefreshInputData('trasportatore_Descrizione_Sede', data.descrizione);
        form.formRefreshInputData('trasportatore_Descrizione_Soggetto', data.descrizioneSoggetto);

        if (data.numeroIscrizioneAlbo && data.alboCategoria) {
          form.formRefreshInputData('autorizzazioneTrasportatoreAlbo_Full', data.alboCategoria.id);
          form.formRefreshInputData('idCategoriaAlboGestoreT', data.alboCategoria.idCategoriaAlboGestore);
          form.formRefreshInputData('idTrasportatoreAlboCategoria', data.alboCategoria.id);
          form.formRefreshInputData('dataInizioCategoriaAlboGestoreTras', data.alboCategoria.dataInizio);
        }

        if (data.autista) {
          if (data.autista.isAutista) {
            const autistaNomeCognome = `${data.autista.nome} - ${data.autista.cognome}`
            form.formRefreshInputData('autista_Cognome_Nome', autistaNomeCognome);
            form.formRefreshInputData('idAutista', data.autista.id);
          } else if (data.autista.isOperatore) {
            const operatoreNomeCognome = `${data.autista.nome} - ${data.autista.cognome}`
            form.formRefreshInputData('descrizione_Operatore_1', operatoreNomeCognome);
            form.formRefreshInputData('idOperatore1', data.autista.id);
          }


        }

        if (data.automezzo) {
          form.formRefreshInputData('automezzo_Descrizione_Full', data.automezzo.targa);
          form.formRefreshInputData('idAutomezzo', data.automezzo.id);
        }

        if (data.rimorchio) {

          form.formRefreshInputData('rimorchio_Descrizione', data.rimorchio.targa);
          form.formRefreshInputData('idRimorchio', data.rimorchio.id);

        }
        break;
      case 'destinatario_Descrizione_Soggetto':
        form.formRefreshInputData('idDestinatario', data.id)
        form.formRefreshInputData('destinatario_Id_Soggetto', data.idSoggetto);
        form.formRefreshInputData('destinatario_Descrizione_Sede', data.descrizione);
        form.formRefreshInputData('destinatario_Descrizione_Soggetto', data.descrizioneSoggetto);

        if (data.autorizzazione && !data.numeroIscrizioneAlbo) {
          form.formRefreshInputData('idAutorizzazioneDestinatario', data.autorizzazione.id);
          form.formRefreshInputData('autorizzazioneDestinatario_Descrizione_Full', data.autorizzazione.numero);
        }

        if (data.autorizzazioneArea) {
          form.formRefreshInputData('idAutorizzazioneDestinatarioArea', data.autorizzazioneArea.id);
          form.formRefreshInputData('autorizzazioneDestinatarioArea_Full', data.autorizzazioneArea.descrizioneArea);
        }


        if (data.magazzinoRifiuti) {
          form.formRefreshInputData('magazzinoDestinatario_Descrizione', data.magazzinoRifiuti.descrizione);
          form.formRefreshInputData('idMagazzinoDestinatario', data.magazzinoRifiuti.id);
        }

        break;

      case 'intermediario_Descrizione_Soggetto':

        form.formRefreshInputData('idIntermediario', data.id)
        form.formRefreshInputData('intermediario_Id_Soggetto', data.idSoggetto);
        form.formRefreshInputData('intermediario_Descrizione_Sede', data.descrizione);
        form.formRefreshInputData('intermediario_Descrizione_Soggetto', data.descrizioneSoggetto);

        if (data.numeroIscrizioneAlbo && data.alboCategoria) {

          form.formRefreshInputData('autorizzazioneIntermediarioAlbo_Full', data.alboCategoria.id);
          form.formRefreshInputData('idCategoriaAlboGestoreI', data.alboCategoria.idCategoriaAlboGestore);
          form.formRefreshInputData('idIntermediarioAlboCategoria', data.alboCategoria.id);
          form.formRefreshInputData('dataIscrizioneAlboI', data.alboCategoria.dataInizio);
        }


        break;
      default:

        break;
    }

    this.tempGuid = null;
    if (this.isEnabeldSessionStorage) {
      let myformData = form.dataSet;
      delete myformData[""];
      sessionStorage.setItem(this.apiset, JSON.stringify(myformData))
    }

  }

  /**Gestione Altri Form Itermendiario e Trasortatore**/

  openEditorAltri(dataToSend, title, popupHeight, popupWidth?) {


    let guid = Math.random().toString().replace("0.", "")
    this.userComponentService.setNewPopUp(guid, 'NewNicaFormComponent', null, popupWidth, null, dataToSend, false, true, title);
    this.userComponentService.outputComponent.subscribe(res => {

      if (res.name === 'formContentInitializzed') {
        res.component.itemOption('altriDatiRifiuto.descrizioneAssegnata', 'disabled', this.disableCerDesc);
      }

      if (res.name == 'onFocusIn' && res.guid == guid) {
        if (!res.value) {

          const dataform = this.formMovimento.dataSet;

          this.formMovimento.formRefreshInputData('kgLordoPesa', dataform.quantitaKg)

          //console.log('onFocusIn', res)
        }


      }

      if (res.name == "onValueChanged" && res.guid == guid) {

        if (res.campo.dataField == 'kgTaraPesa') {
          const kgTaraPesa = res.value;
          const kgLordoPesa = res.formData.kgLordoPesa


          if (kgTaraPesa > kgLordoPesa) {
            //alert('La tara indicata è superiore al peso lordo', 'Attenzione!');
            return
          }


        }

      }

      if (res.name == 'return' && res.guid == guid) {
        this.userComponentService.destroyCurrentOpenPopUp('NewNicaFormComponent')

        return;

      }

      if (res.name == 'submitFormStatic' && res.guid == guid) {

        //delete this._overlaySideFormService._hrefComponent.instance.formEdit.formData['idFantoccio'];

        const formData = res.data

        const kgTaraPesa = formData.kgTaraPesa;
        const kgLordoPesa = formData.kgLordoPesa


        if (kgTaraPesa > kgLordoPesa) {
          alert('La tara indicata è superiore al peso lordo', 'Attenzione!');
          return
        }


        if (Object.keys(formData).length > 0) {
          for (let x in formData) {


            switch (x) {
              case 'kgLordoPesa':
                if (formData['kgTaraPesa']) {

                  const persoKg = formData['kgLordoPesa'] - formData['kgTaraPesa'];

                  this.formMovimento.formRefreshInputData('quantitaKg', persoKg);
                  formData['quantitaKg'] = persoKg
                }

                this.formMovimento.formRefreshInputData('kgLordoPesa', formData['kgLordoPesa'])

                break;

              case 'descrizioneAssegnata':
                this.formMovimento.formRefreshInputData('descrizioneAssegnata', formData['descrizioneAssegnata']);
                break;
              default:
                let mData = this.formMovimento.dataSet

                if (mData.hasOwnProperty(x)) {
                  this.formMovimento.formRefreshInputData(x, formData[x])
                }
                break;
            }



          }

          this.userComponentService.destroyCurrentOpenPopUp('NewNicaFormComponent');
        } else {

          confirm('Non hai inserito nessun dato, vuoi chiudere la finestra?', 'Attenzione!').then(res => {
            if (res) {
              this.userComponentService.destroyCurrentOpenPopUp('NewNicaFormComponent');
            }
          })
        }
      }



    })

    return


  }

  formPanelAltriSoggetti(instanceData, tipSoggetto, title) {

    let componentName = 'GestioneAltriSoggettiComponent'

    let data
    const width = null;

    let guid = Math.random().toString().replace("0.", "")
    this.userComponentService.setNewPopUp(guid, componentName, null, width, true, instanceData, false, false, title);



    this.userComponentService.outputComponent.subscribe(currentOutput => {
      // const copyArray = [...currentOutput.listaAltriSoggetti]
      if (currentOutput.name == "return" && currentOutput.guid == guid) {
        // this.formMovimento.dataSet[currentOutput.retunDatafield] = this.copyArray[currentOutput.retunDatafield];
        this.userComponentService.destroyCurrentOpenPopUp(componentName)
        this.userComponentService.destroyOutputComponent()

      }

      if (currentOutput.name == "saveSoggetto" && currentOutput.guid == guid) {

        let formData = this.formMovimento.dataSet;
        let data = currentOutput
        let idProduttore = formData.idProduttore;
        let idTrasportatore = formData.idTrasportatore;
        let idIntermediario = formData.idIntermediario;

        let arrayIdListaSoggetti = currentOutput.listaAltriSoggetti
        if (data.retunDatafield == 'listaAltriSoggettiT') {

          let trasportatoriArray = arrayIdListaSoggetti.filter(ress => {
            if (ress.idSoggetto == idTrasportatore) {
              return ress
            }
          })

          if (trasportatoriArray.length > 0) {
            let trasportatoreDescArray = trasportatoriArray.map(res => {
              return res.descrizione
            })

            let trasportatore = trasportatoreDescArray.toString()
            notify({
              message: 'Trasportatore/i : ' + trasportatore + ' già scelto come princiale',
              height: 45,
              width: 250,
              position: 'center center'

            }, 'error', 3000);
            console.log('index Trasportatore', trasportatore
            )
            return;

          }


        }

        if (data.retunDatafield == 'listaAltriSoggettiI') {

          let intermediariArray = arrayIdListaSoggetti.filter(ress => {
            if (ress.idSoggetto == idIntermediario) {
              return ress
            }
          })

          if (intermediariArray.length > 0) {
            let trasportatoreDescArray = intermediariArray.map(res => {
              return res.descrizione
            })

            let intermediari = trasportatoreDescArray.toString()

            notify({
              message: 'Intermediario/i : ' + intermediari + ' già scelto come princiale',
              height: 45,
              width: 250,
              position: 'center center'

            }, 'error', 3000);
            console.log('index Trasportatore', intermediari
            )
            return;

          }


        }

        if (data.retunDatafield == 'listaInterventiSpurghi') {
          if (arrayIdListaSoggetti.length > 10) {
            notify({
              message: 'Attenzione!: puoi indicare massimo 10 luoghi di intervento.',
              height: 45,
              width: 250,
              position: 'center center'

            }, 'error', 3000);
            return;
          }



          let sommaQuantita = 0;
          if (arrayIdListaSoggetti.length > 0) {

            const set = new Set()
            const dupilcates = arrayIdListaSoggetti.some((item: any) => {
              const key = item.idProduttoreSede
              if (set.has(key)) {
                return true;
              }
              set.add(key)
            })

            if (dupilcates) {
              notify({
                message: 'Attenzione!: sono presenti dei duplicati.',
                height: 45,
                width: 250,
                position: 'center center'
              }, 'error', 3000);
              return;
            }

            if (formData.quantitaOrigineKg < 1) {
              arrayIdListaSoggetti.forEach((item: any) => {
                sommaQuantita += item.quantita;
              });
              this.formMovimento.formRefreshInputData('quantitaOrigineKg', sommaQuantita)
            }
          }
        }


        this.formMovimento.formRefreshInputData(data.retunDatafield, data.listaAltriSoggetti);
        this.userComponentService.destroyCurrentOpenPopUp(componentName)
        this.userComponentService.destroyOutputComponent()
      }

      //console.log('currentOutput', currentOutput)

    })
  }


  formPanelSchedaTecnica(formData) {
    let title = 'Schede descrittive rifiuto'
    let congiunzione = ''
    let staticQueryFilter = '?$filter=(';

    /*
      Controllare la seguente logica: 
      nei movimenti, quando richiamiamo la scheda descrittiva del rifiuto.

      Al click sull'icona, si deve verificare quanto segue: 
        -se non c'è il produttore indicato, devo vedere LE SCHEDE GENERICHE
        -Se c'è il produttore indicato:
                - Se il produttore ha schede , vedo le schede del produttore
                - Se il produttore non ha neanche una scheda, vedo le schede generiche
        -se seleziono prima il cer, vedo tutte le schede generiche 
    
    */

    if (formData.idLotto_Sede) {

      /*  if (formData.eer) {
         congiunzione = 'And'
       } */
      staticQueryFilter += `${congiunzione} idProduttore eq ${formData.idLotto_Sede}`
    } else {
      /* if (formData.eer) {
        congiunzione = 'And'
      } */
      staticQueryFilter += `${congiunzione} idProduttore eq null`
    }


    if (formData.eer) {

      staticQueryFilter = `?$filter=(eer eq '${formData.eer} AND idProduttore eq null' `
    }

    if (staticQueryFilter != '') {

      staticQueryFilter += `)`

    }

    /* if (!formData.idLotto_Sede) {
      staticQueryFilter = ''
    } */

    /* if (!formData.idLotto_Sede && !formData.eer) {
      staticQueryFilter = ''
    } */



    let componentName = 'SchedarifiutiComponent'

    let dataToSendchedarifiutiComponent = [{
      apiset: '',
      id: '',
      service: 'SchedaRifiuto',
      title: title,
      InviaA: null,
      onlyRead: true,
      filter: JSON.stringify(formData),
      staticQueryFilter: staticQueryFilter,
      templateView: 'grid',
      template: 'grid',
      currentTabName: componentName,
      currentTabId: componentName,
      componentName: componentName


    }]

    const width = '1150';
    let guid = Math.random().toString().replace("0.", "")
    this.userComponentService.setNewPopUp(guid, componentName, dataToSendchedarifiutiComponent, width, null, { buttonToolbarBottomGrid: [0] });

    this.userComponentService.outputComponent.subscribe(currentOutput => {

      if (currentOutput.name == "onSelectionChanged" && currentOutput.componentName == 'SchedarifiutiComponent') {
        //console.log('onSelectionChanged', currentOutput)

        let dataImp = currentOutput.data;

        if (formData.idProduttore) {
          delete dataImp.idProduttore;
          delete dataImp.produttoreDesc;
        }

        if (formData.idTrasportatore) {
          delete dataImp.idTrasportatore;
          delete dataImp.trasportatoreDesc;
        }

        if (formData.idIntermediario) {

          delete dataImp.idIntermediario;
          delete dataImp.intermediarioDesc;

        }

        if (this.isEnabeldSessionStorage) {
          sessionStorage.removeItem(this.apiset)
        }

        for (let x in dataImp) {
          // if (dataImp[x] !== null) {
          switch (x) {
            case 'id':
              this.formMovimento.formRefreshInputData('idSchedaDilavorazione', dataImp[x]);
              delete dataImp.id;
              break;
            case 'isCerPericoloso':
              this.formMovimento.formRefreshInputData('isCerPericoloso', dataImp[x]);
              //aggiungo un refresh del campo eer prima a null e poi con il suo valore effettivo per far partire di nuovo l'onvaluechanged
              //mi serve perchè devo ricontrollare il valore di isCerPericoloso per capire se è un cer pericoloso.
              this.formMovimento.formRefreshInputData('eer', null);
              this.formMovimento.formRefreshInputData('eer', dataImp['eer']);
              break;
            case 'idTestoAdr':
              this.formMovimento.formRefreshInputData('idTestoAdr', dataImp[x]);
              break;
            case 'descrizioneTestoAdr':
              this.formMovimento.formRefreshInputData('testoADR_Descrizione', dataImp[x]);
              break;
            case 'idOnu':
              this.formMovimento.formRefreshInputData('idONU', dataImp[x]);
              break;
            case 'isADR':
              dataImp['isADR'] = 'S';
              this.formMovimento.formRefreshInputData('adr', 'S');
              break;
            case 'analisiCaratterizzazioneNumero':
              this.formMovimento.formRefreshInputData('analisiNumero', dataImp[x]);
              break;
            case 'analisiCaratterizzazioneData':

              this.formMovimento.formRefreshInputData('analisiData', dataImp[x]);
              break;
            case 'descrizioneAssegnata':
              this.formMovimento.formRefreshInputData('descrizioneAssegnata', dataImp['eer'].endsWith('99') ? dataImp[x] : null);
              break;

            case 'analisiCaratterizzazioneScadenza':

              this.formMovimento.formRefreshInputData('analisiScadenza', dataImp[x]);
              break;

            case 'quantitaPrevista':
              const idOperazione = this.formMovimento.dataSet.causale_Id_Operazione
              if (idOperazione == 'A3' || idOperazione == 'A5' || idOperazione == 'C1' || idOperazione == 'C3') {

                const conTonKG = Number(dataImp[x]) * 1000;
                let toString = conTonKG.toString()

                if (toString.length > 11) {
                  return;
                }

                this.formMovimento.formRefreshInputData('quantitaOrigineKg', conTonKG.toFixed(3));
              }
              break
            case 'trasportatoreDesc':

              if (x == 'trasportatoreDesc' && formData.causale_Trasporto != 'N') {

                //this.formMovimento.formRefreshInputData('trasportatore_Descrizione_Full', dataImp['trasportatoreDesc'])
                //this.formMovimento.formRefreshInputData('idTrasportatore', dataImp['idTrasportatore'])

              }

              break;

            case 'produttoreDesc':

              if (x == 'produttoreDesc' && !dataImp['nsAzienza']) {


                //this.formMovimento.formRefreshInputData('produttore_Descrizione_Full', dataImp[x]);
                //this.formMovimento.formRefreshInputData('idProduttore', dataImp['idProduttore']);


              }

              break;
            case 'pesoSpecifico':

              if (dataImp['pesoSpecifico']) {

                this.pesoSpecificoKGMC = dataImp['pesoSpecifico']; //Calcola il peso al metro cubo
                this.formMovimento.formRefreshInputData('pesoSpecificoKGMC', this.pesoSpecificoKGMC);
              }

              if (dataImp['tipoCalcolo']) {
                this.calcolaVolumePeso = dataImp['tipoCalcolo']; //P = Dato il Peso calcola volume  V= Dato il volume calcola il peso  
                this.formMovimento.formRefreshInputData('calcolaVolumePeso', this.calcolaVolumePeso);
              }

              if (this.calcolaVolumePeso == 'P') {

                /*  const pesoSpecifico = parseInt(this.pesoSpecificoKGMC)
                 let volume = peso / pesoSpecifico;
                 component.updateData('volume', volume);
                 component.updateData('unitaMisuraVolume', 'M') */



              }

              break;

            default:
              if (formData.hasOwnProperty(x)) {
                this.formMovimento.formRefreshInputData(x, dataImp[x])
              }
              break;
          }



          /*Gestione dati Omologa e Analisi*/

          // }

        }
        if (this.cd) this.cd.detectChanges()
        this.userComponentService.destroyCurrentOpenPopUp(componentName);
        this.userComponentService.destroyOutputComponent();
        return
      }
      console.log('currentOutput', currentOutput)

    })
  }

  formPanelGiacenze(formData) {

    let title = 'Carichi scaricabili alla data: ' + this.dateParseIT(formData.dataRegistrazione)

    //this.openComponent('GiacenzeRifiutoMovimentoComponent', formData, title, 1300, 890, false)

    let componentName = 'GiacenzeRifiutoMovimentoComponent'
    const dataToSend = [{
      apiset: '',
      id: '',
      service: 'giacenzePanelMovimenti',
      title: title,
      InviaA: null,
      filter: JSON.stringify(formData),
      templateView: 'form',
      currentTabName: componentName,
      currentTabId: componentName,
      componentName: componentName


    }]

    const width = null;
    let guid = Math.random().toString().replace("0.", "")
    this.userComponentService.setNewPopUp(guid, componentName, dataToSend, width);

    this.userComponentService.outputComponent.subscribe(currentOutput => {

      if (currentOutput.name == "selectedRowGiacenze" && currentOutput.guid == guid) {
        console.log('GiacenzeRifiutoMovimentoComponent', currentOutput)
        let dataImp = currentOutput.data;
        for (let x in dataImp) {
          // if (dataImp[x]) {
          if (dataImp.hasOwnProperty('isCerPericoloso')) {
            this.formMovimento.formRefreshInputData('isCerPericoloso', dataImp['isCerPericoloso']);
          }
          console.log(x, dataImp[x])
          this.formMovimento.formRefreshInputData(x, dataImp[x])
          // }

        }

        this.userComponentService.destroyCurrentOpenPopUp(componentName);
        this.userComponentService.destroyOutputComponent();
        return
      }
      //closeTab
      if (currentOutput.name == "closeTab" && currentOutput.componentName == componentName) {
        this.userComponentService.destroyCurrentOpenPopUp(componentName);
        this.userComponentService.destroyOutputComponent();
      }


      if (currentOutput.name == "onRowExpanded" && currentOutput.componentName == componentName) {

        if (currentOutput.expandedData.length == 1) {
          let dataImp = currentOutput.expandedData[0];
          for (let x in dataImp) {
            if (dataImp[x]) {
              this.formMovimento.formRefreshInputData(x, dataImp[x])
            }

          }

          //this.userComponentService.destroyCurrentOpenPopUp(componentName);
          //this.userComponentService.destroyOutputComponent();

        }
      }

      // if (!(formData["eer"].endsWith("99"))) {
      //   formData.descrizioneAssegnata = null
      //   this.formMovimento.formRefreshInputData('altriDatiRifiuto.descrizioneAssegnata', null);

      // }
    })
  }

  optionalButtonClickToolBarMovDoc(event) {
    //alert('dsdsdsd','ddddddd');
    if (event == "resettaFiltro") {


      let filtriOBJ = JSON.parse(sessionStorage.getItem('Filtri'));
      const obj = `${this.apiset}Filtri`;
      delete filtriOBJ[obj];
      sessionStorage.setItem('Filtri', JSON.stringify(filtriOBJ));
      this.resettaFiltroApplicato(obj)
      return
      setTimeout(
        () => {
          for (let i = 0; i < document.getElementsByClassName('dx-icon export icon-filter').length; i++) {
            if ((document.getElementsByClassName('dx-icon export icon-filter').item(i) as HTMLElement).parentElement.parentElement.id == 'bottoneFiltroToolbar') {
              //console.warn('icona trovata');
              (document.getElementsByClassName('dx-icon export icon-filter').item(i) as HTMLElement).style.color = '#023957';
              break;
            }
          }
        }, 500
      );
      this.pannelloFiltriAvanzatiVisibile = false;

      //this.filterGrid = '/'
      //this.nicaAnagrafica.refresh()
    }

    if (event == "pannelloFiltriAvanzatiVisibile") {
      const filtroKeySessionStorage = `${this.apiset}Filtri`
      let instanceData = {
        filtroKeySessionStorage: filtroKeySessionStorage,
        nomeTemplate: 'movimentiRifiutoFiltri2',
        captionHidden: true,
        nColForm: '2',
        helpDoc: `${filtroKeySessionStorage}.html`,
        caption: 'Filtri Avanzati'
      }
      let guid = this.openComponentInPopUP('NicaFiltroComponent', [], instanceData, '1498', 'Filtri Avanzati', false, true, 'center', `${filtroKeySessionStorage}.html`);

      this.userComponentService.outputComponent.subscribe(currentOutput => {

        if (currentOutput.name == 'resettaFiltro' && currentOutput.guid == guid) {
          this.userComponentService.destroyCurrentOpenPopUpByGuid(guid)
          this.resettaFiltroApplicato(filtroKeySessionStorage)
          return
        }

        if (currentOutput.name == 'return' && currentOutput.guid == guid) {
          this.userComponentService.destroyCurrentOpenPopUpByGuid(guid)
          return
        }

        if (currentOutput.name == 'queryOk' && currentOutput.guid == guid) {
          if (currentOutput.oData) {
            // console.log(currentOutput.oData)
            // const formData = JSON.parse(JSON.stringify(currentOutput.formDataAA));
            //   Object.keys(formData).forEach(key => {

            //     switch (key) {
            //         case 'categoriaDocumento_Descrizione':
            //         case 'tipoDocumento_Descrizione':
            //         case 'zonaDocumento_Descrizione':
            //         case 'bacinoDocumento_Descrizione':
            //           delete formData[key]
            //         break;

            //     } 
            //   })

            let queryStringUL22 = `?$filter=${currentOutput.oData}`

            this.onFilterQueryStringEmitted(queryStringUL22)
          }
          this.userComponentService.destroyCurrentOpenPopUp('NicaFiltroComponent');
        }

      });



    }
  }

  openEditorSoggetti(event) {
    // console.log(event)
    let path = ''
    let dataFields = !event.campo.dynamic.related ? [] : event.campo.dynamic.related;
    let service = '';
    let api = '';
    let currentTabName = ''
    let componentName = '';
    let Filter = {}
    this.tempGuid = Math.random().toString(36).substring(2, 10);
    const instanceData = {}
    const guidPopup = Math.random().toString().replace("0.", "");
    const dataGridComponent = event.dataGridComponent as NicaDataGridComponent
    const filterOdata = dataGridComponent.filterOdata || ''
    switch (event.campo.dataField) {
      case 'produttore_Descrizione_Soggetto':
      case 'destinatario_Descrizione_Soggetto':
      case 'trasportatore_Descrizione_Soggetto':
      case 'intermediario_Descrizione_Soggetto':
        dataFields.push(`descrizioneSoggetto|${event.campo.dataField}`);
        path = 'main/anagrafiche-operatori';
        service = "soggetto";
        api = "soggetto";
        componentName = "AnaSoggettoComponent";
        currentTabName = "Anagrafica Operatori"
        Filter = {
          NostreAziende: 'N',
          nsAzienda: false
        }
        break;
      case 'autorizzazioneProduttore_Descrizione_Full':
        // path = 'main/anagrafica-autorizzazione';
        // service = "autorizzazione";
        // api = "autorizzazione";
        // componentName = "AnaAutorizzazioneComponent";
        // currentTabName = 'Autorizzazione'
        // dataFields.push(`numero|${event.campo.dataField}`);
        // Filter = {
        //   idSede: event.formData.idProduttore,
        //   nsAzienda: this.filterID['nsAziendaProd'],
        //   descrizioneSede: event.formData.produttore_Descrizione_Sede,
        //   descrizioneSoggetto: event.formData.produttore_Descrizione_Soggetto
        // }
        // break;
        Object.assign(instanceData, {
          service: 'autorizzazione',
          api: 'autorizzazione',
          nCol: 2,
          heightForm: 600,
          dataJson: {
            "idSede": event.formData.idProduttore,
          }
        })

        this.userComponentService.setNewPopUp(guidPopup, 'NewNicaFormComponent', null, '1600', null, instanceData, false, true, 'Inserisci Autorizzazione Produttore');
        this.userComponentService.outputComponent.subscribe(currentOutput => {
          if (currentOutput.name === "submittedInsertOk" && currentOutput.guid === guidPopup) {
            if (currentOutput.guid) this.userComponentService.destroyCurrentOpenPopUpByGuid(currentOutput.guid)
            if (dataGridComponent) dataGridComponent.refresh(filterOdata)
          }
          if (currentOutput.name === "return" && currentOutput.guid === guidPopup) {
            if (currentOutput.guid) this.userComponentService.destroyCurrentOpenPopUpByGuid(currentOutput.guid)
            if (dataGridComponent) dataGridComponent.refresh(filterOdata)
          }
        })
        return
      case 'produttoreAlboCategoria_Descrizione_Full':
        // path = 'main/anagrafica-albo';
        // service = "AlboCategoria";
        // api = "AlboCategoria";
        // componentName = "AnaAlboComponent";
        // currentTabName = 'Categ. Albo'
        // dataFields.push(`id|${event.campo.dataField}`);
        // Filter = {
        //   idSede: event.formData.idProduttore,
        //   nsAzienda: this.filterID['nsAziendaProd'],
        //   descrizioneSede: event.formData.produttore_Descrizione_Sede,
        //   descrizioneSoggetto: event.formData.produttore_Descrizione_Soggetto
        // }
        Object.assign(instanceData, {
          service: 'AlboCategoria',
          api: 'AlboCategoria',
          nCol: 1,
          heightForm: 700,
          // type: 'tabbed',
          dataJson: {
            "idSede": event.formData.idProduttore,
          }
        })
        this.userComponentService.setNewPopUp(guidPopup, 'NewNicaFormComponent', null, '1400', null, instanceData, false, true, 'Inserisci Produttore Albo Categoria');
        this.userComponentService.outputComponent.subscribe(currentOutput => {
          if (currentOutput.name === "submittedInsertOk" && currentOutput.guid === guidPopup) {
            if (currentOutput.guid) this.userComponentService.destroyCurrentOpenPopUpByGuid(currentOutput.guid)
            if (dataGridComponent) dataGridComponent.refresh(filterOdata)
          }
          if (currentOutput.name === "return" && currentOutput.guid === guidPopup) {
            if (currentOutput.guid) this.userComponentService.destroyCurrentOpenPopUpByGuid(currentOutput.guid)
            if (dataGridComponent) dataGridComponent.refresh(filterOdata)
          }
        })
        return;
      case 'automezzo_Descrizione_Full':
      case 'rimorchio_Descrizione':
        // path = 'main/anagrafica-automezzo';
        // service = "automezzo";
        // api = "Automezzo";
        // componentName = "AnaAutomezzoComponent";
        // currentTabName = 'Automezzo'
        // dataFields.push(`targa|${event.campo.dataField}`);
        // Filter = {
        //   idSede: event.formData.idTrasportatore,
        //   nsAzienda: this.filterID['nsAziendaTrasp'],
        //   descrizioneSede: event.formData.produttore_Descrizione_Sede,
        //   descrizioneSoggetto: event.formData.produttore_Descrizione_Soggetto
        // }
        // break;
        Object.assign(instanceData, {
          service: 'automezzo',
          api: 'Automezzo',
          nCol: 1,
          heightForm: 400,
          dataJson: {
            "idSede": event.formData.idTrasportatore,
          }
        })
        this.userComponentService.setNewPopUp(guidPopup, 'NewNicaFormComponent', null, '900', null, instanceData, false, true, `Inserisci ${event.campo.dataField.split('_')[0].replace(/\b[a-z]/g, (char) => char.toUpperCase())}`);
        this.userComponentService.outputComponent.subscribe(currentOutput => {
          if (currentOutput.name === "submittedInsertOk" && currentOutput.guid === guidPopup) {
            if (currentOutput.guid) this.userComponentService.destroyCurrentOpenPopUpByGuid(currentOutput.guid)
            if (dataGridComponent) dataGridComponent.refresh(filterOdata)
          }
          if (currentOutput.name === "return" && currentOutput.guid === guidPopup) {
            if (currentOutput.guid) this.userComponentService.destroyCurrentOpenPopUpByGuid(currentOutput.guid)
            if (dataGridComponent) dataGridComponent.refresh(filterOdata)
          }
        })
        return
      default:
        break;
    }
    Filter = {
      ...Filter,
      movimento: true,
      provieniDa: this.apiset,
      serviceId: service,
      dataField: event.campo.dataField,
      accessoringData: dataFields,

    }

    const queryFilter = JSON.stringify(Filter);

    const navigationParams = {

      api: api,
      service: service,
      masterKey: 'id',
      filter: queryFilter,
      queryFilter: '',
      descEvent: '',
      templateView: 'form',
      titoloDaPortare: '',
      data: null,
      currentTabId: this.tempGuid,
      currentTabName: currentTabName,
      componentName: componentName,
      vengoDaId: this.currentTabId || undefined
    }

    if (!path) {
      return
    }
    this.router.navigate(
      [path],
      {
        queryParams: navigationParams,
        skipLocationChange: false,
        replaceUrl: true
      }
    ).then(res => {
      this.userComponentService.destroyCurrentOpenPopUpByGuid(event.guid);
    })
    //Cerca su accessoringData per trovare il metodo che aggiorna gli elementi una vota creati.
  }

  async onFilterQueryStringEmitted(queryString: any) {

    //console.log("Tipo di queryString ricevuta:", typeof queryString, queryString); 

    // Assicurarsi che queryString sia una stringa e non sia vuota
    queryString = typeof queryString === 'string' ? queryString.trim() : "";
    if (queryString.length === 0) {

      return;
    }

    // Verifica se la griglia è disponibile
    if (!this.nicaAnagrafica.griglia.instance) {
      return;
    }
    this.updateFilterGrid(queryString);
    this.updateFilterIconColors(true);

    return
    // Procedi con il caricamento dei dati di filtro
    console.log("QueryString prima del caricamento dei dati:", queryString);
    let filterData = await this.loadFilterData(queryString);
    if (!filterData) {
      console.error("Errore: Nessun dato di filtro ricevuto.");
      return;
    }

    console.log("Dati filtro ricevuti:", filterData);
    const updatedQueryString = this.buildFilterQuery(filterData);
    console.log("QueryString aggiornata:", updatedQueryString);
    this.applyFilterSettings(updatedQueryString);
  }

  private async loadFilterData(queryString: string): Promise<any> {
    console.log('Caricamento dati con queryString:', queryString);
    try {
      const response = await this.anagraficaService.getElenco(this.apiset, '', queryString)
      //anagraficaService.getElenco(this.apiset ${environment.BASE_API_URL}MovimentoRifiuti${queryString}`).toPromise();
      console.log('Dati ricevuti:', response);
      // Aggiungi un controllo qui per verificare che i dati siano quelli attesi
      if (!response) {
        console.log('Nessun dato ricevuto per la queryString:', queryString);
        return null;
      }
      return response;
    } catch (error) {
      console.error("Errore durante il caricamento dei dati:", error);
      return null;
    }
  }

  buildFilterQuery(filters: FilterData): string {
    if (!filters || !filters.items || filters.items.length === 0) {
      console.log('Nessun filtro valido ricevuto');
      return "$filter=id eq null";
    }

    let query = "$filter=";
    filters.items.forEach(item => {
      if (item.id && typeof item.id === 'number') {
        query += ` (id eq ${item.id}) or`;
      }
    });

    // Rimuovi l'ultimo "or" dalla stringa di query se esistente
    if (query.length > "$filter=".length) {
      return query.slice(0, -3);
    } else {
      // Se nessun Id è stato aggiunto, restituisci una stringa vuota o un'altra logica appropriata
      console.log('Nessun Id valido per la query');
      return "$filter=id eq null"; // Usa un default logicamente inattivo
    }
  }

  private applyFilterSettings(queryString: string): void {
    console.log("Applicazione delle impostazioni di filtro con queryString:", queryString);

    if (!queryString || queryString.length === 0) {
      console.error("Errore: queryString non definita o vuota.");
      return;
    }

    try {
      this.updateFilterGrid(queryString);
      this.updateFilterIconColors(true);
      console.log("Aggiornamento della griglia con la nuova queryString.");
      if (!this.nicaAnagrafica || !this.nicaAnagrafica.griglia || !this.nicaAnagrafica.griglia.instance) {
        console.error('Impossibile aggiornare la griglia: componente griglia non disponibile');
        return;
      }

      this.nicaAnagrafica.griglia.instance.refresh();
      console.log("Griglia aggiornata con successo.");
    } catch (error) {
      console.error("Errore durante l'aggiornamento della griglia:", error);
    }

    try {
      console.log("Tentativo di chiusura del popup.");
      this.userComponentService.destroyCurrentOpenPopUp('NicaFiltroComponent');
      console.log("Popup chiuso con successo.");
      this.pannelloFiltriAvanzatiVisibile = false;
    } catch (error) {
      console.error("Errore durante la chiusura del popup:", error);
    }
  }

  updateFilterGrid(queryFilter: string): void {



    const orderbyRegex = /([?&])\$orderby=[^&]*/;
    const orderbyMatch = this.filterGrid.match(orderbyRegex) || [''];
    const countRegex = /([?&])\$count=[^&]*/;
    const countMatch = this.filterGrid.match(countRegex) || [''];
    const filterRegex = /([?&])\$filter=[^&]*/;
    const filterMatch = this.filterGrid.match(filterRegex) || [''];

    // Se non c'è orderby, semplicemente aggiungi il filtro
    if (!orderbyMatch) {
      this.filterGrid = this.filterGrid + queryFilter;
      this.nicaAnagrafica.refresh()
      return
    }

    // Step 2: Rimuovi la parte trovata dalla stringa originale
    const orderbyPart = orderbyMatch[0] || '';
    const countPart = countMatch[0] || '';
    const filterPart: string = filterMatch[0] || '';
    let cleanedQueryString = this.filterGrid.replace(orderbyPart, '').replace(countPart, '').replace(filterPart, '');;

    if (cleanedQueryString.includes('&')) {
      cleanedQueryString = cleanedQueryString.replace('&', '')
    }

    // if (cleanedQueryString.includes('?$filter=')) {
    //   // queryFilter=queryFilter + cleanedQueryString.replace('?$filter=','');
    //   cleanedQueryString = ''
    // }

    // Step 3: Aggiungi il tuo filtro query
    const newQueryString = cleanedQueryString + queryFilter;

    // Step 4: Reinserisci la parte orderby alla fine della stringa

    let orderby = orderbyPart.includes('?') ? orderbyPart.replace('?', '&') : orderbyPart
    let count = countPart.includes('?') ? countPart.replace('?', '&') : countPart
    let oldFilter = newQueryString.includes(filterPart) ? '' : filterPart.includes('?') ? filterPart.replace('?', '&') : filterPart
    this.filterGrid = newQueryString + count + orderby;

    this.nicaAnagrafica.refresh()
  }

  updateFilterIconColors(hasQuery: boolean): void {
    const color = hasQuery ? '#edcd5f' : '#023957';
    Array.from(document.getElementsByClassName('dx-icon export icon-filter')).forEach(
      icon => (icon as HTMLElement).style.color = color
    );
  }


  movimentoDetailInit(event) {

    console.log('movimentoDetailInit', event)

    let masterDetail = this.formservice.getTemplateService('DammiInfoMovimento')

    event.component.option('masterDetail', masterDetail);

  }
}
